webpackJsonp([1],{

/***/ 1187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__casTokenStrategy__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jwtTokenStrategy__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colaboratorTokenStrategy__ = __webpack_require__(318);






var TokenStrategyFactory = function () {
  function TokenStrategyFactory() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TokenStrategyFactory);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TokenStrategyFactory, null, [{
    key: 'getTokenStrategy',
    value: function getTokenStrategy(tokenKind) {
      switch (tokenKind) {
        case 'jwt':
          return new __WEBPACK_IMPORTED_MODULE_3__jwtTokenStrategy__["a" /* default */]();
        case 'cas':
          return new __WEBPACK_IMPORTED_MODULE_2__casTokenStrategy__["a" /* default */]();
        case 'colaborator':
          return new __WEBPACK_IMPORTED_MODULE_4__colaboratorTokenStrategy__["a" /* default */]();
        default:
          throw new Error('invalid token kind');
      }
    }
  }]);

  return TokenStrategyFactory;
}();

/* harmony default export */ __webpack_exports__["a"] = (TokenStrategyFactory);

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var dateHelper = {};

dateHelper.isInvalidPeriod = function (date1, date2) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date1).isAfter(date2);
};

dateHelper.subtractDays = function (date, interval) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).subtract(interval, 'days').toDate();
};

dateHelper.truncate = function (date) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(date).startOf('day').format();
};

dateHelper.today = function () {
  return dateHelper.truncate(new Date());
};

dateHelper.formatedDate = function (date, format) {
  var formatUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var adjustedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date);
  adjustedDate = formatUTC ? adjustedDate.utc() : adjustedDate.local();
  return adjustedDate.format(format);
};

dateHelper.todayFormated = function (format) {
  return dateHelper.formatedDate(dateHelper.today(), format);
};

/* harmony default export */ __webpack_exports__["a"] = (dateHelper);

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 486,
	"./af.js": 486,
	"./ar": 494,
	"./ar-dz": 487,
	"./ar-dz.js": 487,
	"./ar-kw": 488,
	"./ar-kw.js": 488,
	"./ar-ly": 489,
	"./ar-ly.js": 489,
	"./ar-ma": 490,
	"./ar-ma.js": 490,
	"./ar-ps": 491,
	"./ar-ps.js": 491,
	"./ar-sa": 492,
	"./ar-sa.js": 492,
	"./ar-tn": 493,
	"./ar-tn.js": 493,
	"./ar.js": 494,
	"./az": 495,
	"./az.js": 495,
	"./be": 496,
	"./be.js": 496,
	"./bg": 497,
	"./bg.js": 497,
	"./bm": 498,
	"./bm.js": 498,
	"./bn": 500,
	"./bn-bd": 499,
	"./bn-bd.js": 499,
	"./bn.js": 500,
	"./bo": 501,
	"./bo.js": 501,
	"./br": 502,
	"./br.js": 502,
	"./bs": 503,
	"./bs.js": 503,
	"./ca": 504,
	"./ca.js": 504,
	"./cs": 505,
	"./cs.js": 505,
	"./cv": 506,
	"./cv.js": 506,
	"./cy": 507,
	"./cy.js": 507,
	"./da": 508,
	"./da.js": 508,
	"./de": 511,
	"./de-at": 509,
	"./de-at.js": 509,
	"./de-ch": 510,
	"./de-ch.js": 510,
	"./de.js": 511,
	"./dv": 512,
	"./dv.js": 512,
	"./el": 513,
	"./el.js": 513,
	"./en-au": 514,
	"./en-au.js": 514,
	"./en-ca": 515,
	"./en-ca.js": 515,
	"./en-gb": 516,
	"./en-gb.js": 516,
	"./en-ie": 517,
	"./en-ie.js": 517,
	"./en-il": 518,
	"./en-il.js": 518,
	"./en-in": 519,
	"./en-in.js": 519,
	"./en-nz": 520,
	"./en-nz.js": 520,
	"./en-sg": 521,
	"./en-sg.js": 521,
	"./eo": 522,
	"./eo.js": 522,
	"./es": 526,
	"./es-do": 523,
	"./es-do.js": 523,
	"./es-mx": 524,
	"./es-mx.js": 524,
	"./es-us": 525,
	"./es-us.js": 525,
	"./es.js": 526,
	"./et": 527,
	"./et.js": 527,
	"./eu": 528,
	"./eu.js": 528,
	"./fa": 529,
	"./fa.js": 529,
	"./fi": 530,
	"./fi.js": 530,
	"./fil": 531,
	"./fil.js": 531,
	"./fo": 532,
	"./fo.js": 532,
	"./fr": 535,
	"./fr-ca": 533,
	"./fr-ca.js": 533,
	"./fr-ch": 534,
	"./fr-ch.js": 534,
	"./fr.js": 535,
	"./fy": 536,
	"./fy.js": 536,
	"./ga": 537,
	"./ga.js": 537,
	"./gd": 538,
	"./gd.js": 538,
	"./gl": 539,
	"./gl.js": 539,
	"./gom-deva": 540,
	"./gom-deva.js": 540,
	"./gom-latn": 541,
	"./gom-latn.js": 541,
	"./gu": 542,
	"./gu.js": 542,
	"./he": 543,
	"./he.js": 543,
	"./hi": 544,
	"./hi.js": 544,
	"./hr": 545,
	"./hr.js": 545,
	"./hu": 546,
	"./hu.js": 546,
	"./hy-am": 547,
	"./hy-am.js": 547,
	"./id": 548,
	"./id.js": 548,
	"./is": 549,
	"./is.js": 549,
	"./it": 551,
	"./it-ch": 550,
	"./it-ch.js": 550,
	"./it.js": 551,
	"./ja": 552,
	"./ja.js": 552,
	"./jv": 553,
	"./jv.js": 553,
	"./ka": 554,
	"./ka.js": 554,
	"./kk": 555,
	"./kk.js": 555,
	"./km": 556,
	"./km.js": 556,
	"./kn": 557,
	"./kn.js": 557,
	"./ko": 558,
	"./ko.js": 558,
	"./ku": 560,
	"./ku-kmr": 559,
	"./ku-kmr.js": 559,
	"./ku.js": 560,
	"./ky": 561,
	"./ky.js": 561,
	"./lb": 562,
	"./lb.js": 562,
	"./lo": 563,
	"./lo.js": 563,
	"./lt": 564,
	"./lt.js": 564,
	"./lv": 565,
	"./lv.js": 565,
	"./me": 566,
	"./me.js": 566,
	"./mi": 567,
	"./mi.js": 567,
	"./mk": 568,
	"./mk.js": 568,
	"./ml": 569,
	"./ml.js": 569,
	"./mn": 570,
	"./mn.js": 570,
	"./mr": 571,
	"./mr.js": 571,
	"./ms": 573,
	"./ms-my": 572,
	"./ms-my.js": 572,
	"./ms.js": 573,
	"./mt": 574,
	"./mt.js": 574,
	"./my": 575,
	"./my.js": 575,
	"./nb": 576,
	"./nb.js": 576,
	"./ne": 577,
	"./ne.js": 577,
	"./nl": 579,
	"./nl-be": 578,
	"./nl-be.js": 578,
	"./nl.js": 579,
	"./nn": 580,
	"./nn.js": 580,
	"./oc-lnc": 581,
	"./oc-lnc.js": 581,
	"./pa-in": 582,
	"./pa-in.js": 582,
	"./pl": 583,
	"./pl.js": 583,
	"./pt": 585,
	"./pt-br": 584,
	"./pt-br.js": 584,
	"./pt.js": 585,
	"./ro": 586,
	"./ro.js": 586,
	"./ru": 587,
	"./ru.js": 587,
	"./sd": 588,
	"./sd.js": 588,
	"./se": 589,
	"./se.js": 589,
	"./si": 590,
	"./si.js": 590,
	"./sk": 591,
	"./sk.js": 591,
	"./sl": 592,
	"./sl.js": 592,
	"./sq": 593,
	"./sq.js": 593,
	"./sr": 595,
	"./sr-cyrl": 594,
	"./sr-cyrl.js": 594,
	"./sr.js": 595,
	"./ss": 596,
	"./ss.js": 596,
	"./sv": 597,
	"./sv.js": 597,
	"./sw": 598,
	"./sw.js": 598,
	"./ta": 599,
	"./ta.js": 599,
	"./te": 600,
	"./te.js": 600,
	"./tet": 601,
	"./tet.js": 601,
	"./tg": 602,
	"./tg.js": 602,
	"./th": 603,
	"./th.js": 603,
	"./tk": 604,
	"./tk.js": 604,
	"./tl-ph": 605,
	"./tl-ph.js": 605,
	"./tlh": 606,
	"./tlh.js": 606,
	"./tr": 607,
	"./tr.js": 607,
	"./tzl": 608,
	"./tzl.js": 608,
	"./tzm": 610,
	"./tzm-latn": 609,
	"./tzm-latn.js": 609,
	"./tzm.js": 610,
	"./ug-cn": 611,
	"./ug-cn.js": 611,
	"./uk": 612,
	"./uk.js": 612,
	"./ur": 613,
	"./ur.js": 613,
	"./uz": 615,
	"./uz-latn": 614,
	"./uz-latn.js": 614,
	"./uz.js": 615,
	"./vi": 616,
	"./vi.js": 616,
	"./x-pseudo": 617,
	"./x-pseudo.js": 617,
	"./yo": 618,
	"./yo.js": 618,
	"./zh-cn": 619,
	"./zh-cn.js": 619,
	"./zh-hk": 620,
	"./zh-hk.js": 620,
	"./zh-mo": 621,
	"./zh-mo.js": 621,
	"./zh-tw": 622,
	"./zh-tw.js": 622
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1286;

/***/ }),

/***/ 1436:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emails_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c23534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emails_vue__ = __webpack_require__(1471);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c23534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf6c2824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__ = __webpack_require__(1489);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf6c2824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94db0b4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__(1485);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94db0b4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6471e140_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(1479);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6471e140_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9c8e02e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1491);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9c8e02e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartLogout_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c729c4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartLogout_vue__ = __webpack_require__(1484);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartLogout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c729c4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartLogout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Surrogate_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4c0356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Surrogate_vue__ = __webpack_require__(1480);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Surrogate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4c0356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Surrogate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf95f38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1475);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf95f38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8dd3e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1473);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8dd3e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KlickartHeaderSubtitle_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2d2103a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KlickartHeaderSubtitle_vue__ = __webpack_require__(1487);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KlickartHeaderSubtitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2d2103a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KlickartHeaderSubtitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEditorHeaderSubtitle_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62414f82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEditorHeaderSubtitle_vue__ = __webpack_require__(1478);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEditorHeaderSubtitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62414f82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEditorHeaderSubtitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a29dd7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1470);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a29dd7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9c35ea0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(1488);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9c35ea0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7203fb98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1481);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7203fb98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dd4bbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1472);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dd4bbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AverageTime_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d612a1cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AverageTime_vue__ = __webpack_require__(1490);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AverageTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d612a1cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AverageTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conversions_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96fce770_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conversions_vue__ = __webpack_require__(1486);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conversions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96fce770_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conversions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visitors_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d8a11d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visitors_vue__ = __webpack_require__(1474);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visitors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d8a11d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visitors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7c00eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__ = __webpack_require__(1467);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7c00eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3c4c39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__ = __webpack_require__(1476);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3c4c39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Metrics_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc6b9ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Metrics_vue__ = __webpack_require__(1483);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Metrics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc6b9ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Metrics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusMain_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27dea0a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusMain_vue__ = __webpack_require__(1469);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27dea0a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07895259_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__(1466);
function injectStyle (ssrContext) {
  __webpack_require__(1190)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07895259_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b99af56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(1482);
function injectStyle (ssrContext) {
  __webpack_require__(1192)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b99af56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentReadyToRender)?_c('div',[_c('universal-navigator'),_vm._v(" "),_c('router-view')],1):_c('TheGlobalLoading')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"error__title"},[_vm._v(" "+_vm._s(_vm.errorTitle)+" ")]),_vm._v(" "),_c('span',{staticClass:"error__subtitle"},[_vm._v(" "+_vm._s(_vm.errorSubtitle)+" ")]),_vm._v(" "),_c('div',{staticClass:"error__buttons"},[(_vm.displaySecondaryErrorButton)?_c('button',{staticClass:"secondary",on:{"click":_vm.secondaryErrorButtonFunction}},[_vm._v(" "+_vm._s(_vm.secondaryErrorButtonText))]):_vm._e(),_vm._v(" "),(_vm.displayPrimaryErrorButton)?_c('button',{staticClass:"primary",on:{"click":_vm.primaryErrorButtonFunction}},[_vm._v(" "+_vm._s(_vm.primaryErrorButtonText))]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error__icon"},[_c('img',{attrs:{"src":__webpack_require__(1436)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"box box--no-color form form--inline"},[_c('div',[_c('h3',{staticClass:"form__title"},[_vm._v(_vm._s(_vm.$t('chart.period'))+":")]),_vm._v(" "),_c('div',{staticClass:"input--inline"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('chart.date.from')))]),_vm._v(" "),_c('datepicker',{attrs:{"format":_vm.$t('date.simpleFormat'),"language":_vm.datepickerLanguage[_vm.i18n.locale],"use-utc":true},model:{value:(_vm.filters.start),callback:function ($$v) {_vm.filters.start=$$v},expression:"filters.start"}})],1),_vm._v(" "),_c('div',{staticClass:"input--inline"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('chart.date.to')))]),_vm._v(" "),_c('datepicker',{attrs:{"format":_vm.$t('date.simpleFormat'),"language":_vm.datepickerLanguage[_vm.i18n.locale],"use-utc":true},model:{value:(_vm.filters.end),callback:function ($$v) {_vm.filters.end=$$v},expression:"filters.end"}})],1)]),_vm._v(" "),_c('div',{staticClass:"tab tab--bordered align-center"},[_c('label',{staticClass:"tab__item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.granularity),expression:"filters.granularity"}],attrs:{"type":"radio","value":"hour"},domProps:{"checked":_vm._q(_vm.filters.granularity,"hour")},on:{"__c":function($event){_vm.filters.granularity="hour"}}}),_vm._v(" "),_c('span',{staticClass:"tab__text"},[_vm._v(_vm._s(_vm.$t('chart.granularity.hour.label')))])]),_vm._v(" "),_c('label',{staticClass:"tab__item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.granularity),expression:"filters.granularity"}],attrs:{"type":"radio","value":"day"},domProps:{"checked":_vm._q(_vm.filters.granularity,"day")},on:{"__c":function($event){_vm.filters.granularity="day"}}}),_vm._v(" "),_c('span',{staticClass:"tab__text"},[_vm._v(_vm._s(_vm.$t('chart.granularity.day.label')))])])]),_vm._v(" "),_c('span',{staticClass:"button button--gradient-blue",attrs:{"type":"button"},on:{"click":function($event){_vm.filterChart()}}},[_vm._v("\n      "+_vm._s(_vm.$t('chart.filter'))+"\n    ")])]),_vm._v(" "),(_vm.loaded)?_c('line-chart',{staticClass:"box box--no-color"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchbar"},[_c('div',{staticClass:"container no-padding"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"title__icon icon-kp-graph mobile-hide",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"breadcrumb mobile-hide"},[_c('router-link',{staticClass:"breadcrumb__item",attrs:{"to":{ name: 'Show', params: { locale: _vm.i18n.locale, pageIdentifier: _vm.$route.params.pageIdentifier }}}},[_vm._v("\n          "+_vm._s(_vm.$t('analytics.header.title'))+"\n        ")]),_vm._v(" "),(_vm.breadcrumb)?_c('span',{staticClass:"breadcrumb__item"},[_vm._v(_vm._s(_vm.breadcrumb))]):_vm._e()],1),_vm._v(" "),_c('a',{staticClass:"mt-desktop--largee button-back",attrs:{"href":_vm.klickartUrl}},[_c('i',{staticClass:"button__icon fa fa-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('analytics.header.back'))+"\n      ")])]),_vm._v(" "),(_vm.isKlickartPage)?_c('klickart-header-subtitle'):_c('new-editor-header-subtitle')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAccepted)?_c('loading'):(_vm.isNotFound)?_c('error',{attrs:{"errorTitle":_vm.$t('error.notFound.title'),"displayPrimaryErrorButton":true,"primaryErrorButtonText":_vm.$t('error.notFound.buttons.home'),"displaySecondaryErrorButton":false},on:{"primaryErrorButtonFunction":_vm.redirectToPages}}):(_vm.isUnprocessableEntity)?_c('error',{attrs:{"errorTitle":_vm.$t('error.metricsProcess.title'),"errorSubtitle":_vm.$t('error.metricsProcess.subtitle'),"displayPrimaryErrorButton":true,"primaryErrorButtonText":_vm.$t('error.metricsProcess.buttons.home'),"displaySecondaryErrorButton":true,"secondaryErrorButtonText":_vm.$t('error.metricsProcess.buttons.support')},on:{"primaryErrorButtonFunction":_vm.primaryErrorButtonFunction,"secondaryErrorButtonFunction":_vm.redirectToSupport}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table--striped"},[_c('tr',{staticClass:"title"},[_c('th',[_vm._v(_vm._s(_vm.$t('boxes.visitors.local')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('boxes.visitors.country')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('boxes.visitors.visits')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('locations.visitors_percent')))])]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('tr',{key:location.id,staticClass:"item"},[_c('th',[_vm._v(_vm._s(location.city_name || _vm.$t('locations.not_identified')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(location.country_name || _vm.$t('locations.not_identified')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(location.visits))]),_vm._v(" "),_c('th',[_vm._v(" "+_vm._s(location.visitsPercentage)+"% ")])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfPages > 1),expression:"numberOfPages > 1"}],staticClass:"pagination-cont"},[_c('div',{staticClass:"pagination"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage !== 1),expression:"currentPage !== 1"}],staticClass:"pagination__item",on:{"click":function($event){_vm.getLocationsOfPage(_vm.currentPage - 1)}}},[_vm._v("«")]),_vm._v(" "),_vm._l((_vm.numberOfPages),function(page){return _c('a',{key:page,staticClass:"pagination__item",class:{ 'active' : _vm.currentPage == page },on:{"click":function($event){_vm.getLocationsOfPage(page)}}},[_vm._v("\n        "+_vm._s(page)+"\n      ")])}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage !== _vm.numberOfPages),expression:"currentPage !== numberOfPages"}],staticClass:"pagination__item",on:{"click":function($event){_vm.getLocationsOfPage(_vm.currentPage + 1)}}},[_vm._v("»")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('klickart-analytics-header',{attrs:{"breadcrumb":_vm.$t('emailsList.title')}}),_vm._v(" "),_c('div',{staticClass:"container no-padding"},[_c('div',{staticClass:"box box--purple no-padding"},[_c('header',{staticClass:"clearfix p-large p-mobile--small"},[_c('span',{staticClass:"fz--medium pt--xsmall pulled-left mobile-full"},[_c('i',{staticClass:"icon-kp-mail mr--small va--middle"}),_vm._v("\n          "+_vm._s(_vm.$tc('emailsList.capturedEmails', _vm.numberOfEmails, { count: _vm.numberOfEmails}))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"pulled-right"},[_c('button',{staticClass:"button button--purple mobile-full",on:{"click":_vm.exportEmails}},[_c('i',{staticClass:"fa icon-kp-arrow-down"}),_vm._v(_vm._s(_vm.$t('emailsList.export.button'))+"\n          ")]),_vm._v(" "),_c('input-search')],1)]),_vm._v(" "),_c('list',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfEmails > 0),expression:"numberOfEmails > 0"}]})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isStatusOk)?_c('global-response-status',{on:{"primaryErrorButtonFunction":_vm.retryPageMetrics}}):_c('div',{staticClass:"container no-padding"},[_c('metrics'),_vm._v(" "),_c('chart',{attrs:{"pageIdentifier":_vm.pageIdentifier}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__search"},[_c('input',{staticClass:"input mobile-full",attrs:{"type":"text","placeholder":_vm.$t('emailsList.searchPlaceholder')},on:{"input":_vm.searchCapturedEmails}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-xs-12"},[_c('div',{staticClass:"box box--blue"},[_c('h2',{staticClass:"box__title"},[_vm._v(_vm._s(_vm.$t('boxes.visitors.title')))]),_vm._v(" "),_c('div',{staticClass:"collumns",class:{ 'collumns--bordered': _vm.hasLocations() }},[_c('div',{staticClass:"collumn"},[_c('h3',{staticClass:"collumn__title"},[_vm._v(_vm._s(_vm.$t('boxes.total')))]),_vm._v(" "),_c('span',{staticClass:"fz--large"},[_vm._v(_vm._s(_vm.visitors.total))])]),_vm._v(" "),_c('ul',{staticClass:"list collumn"},[_c('li',{staticClass:"list__item"},[_c('h3',{staticClass:"list__title"},[_vm._v(_vm._s(_vm.$t('boxes.visitors.unique')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.visitors.unique)+" "),_c('span',{staticClass:"fz--small"},[_vm._v(_vm._s(_vm.visitors.uniquePercentage)+"%")])])]),_vm._v(" "),_vm._l((_vm.visitors.devices),function(device){return _c('li',{key:device.name,staticClass:"list__item"},[_c('h3',{staticClass:"list__title"},[_vm._v(_vm._s(device.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(device.total)+" "),_c('span',{staticClass:"fz--small"},[_vm._v(_vm._s(device.percentage)+"%")])])])})],2)]),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasLocations()),expression:"hasLocations()"}],staticClass:"table table--simple table--highlight-first"},[_c('tr',{staticClass:"title"},[_c('th',[_vm._v(_vm._s(_vm.$t('boxes.visitors.local')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('boxes.visitors.country')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('boxes.visitors.visits')))])]),_vm._v(" "),_vm._l((_vm.visitors.locations),function(location){return _c('tr',{key:location.id,staticClass:"item"},[_c('th',[_vm._v(_vm._s(location.city_name || _vm.$t('locations.not_identified')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(location.country_name || _vm.$t('locations.not_identified')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(location.visits))])])})],2),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasLocations()),expression:"hasLocations()"}],staticClass:"button button--small--blue",attrs:{"to":{ name: 'Locations', params: { locale: _vm.i18n.locale, pageIdentifier: _vm.$route.params.pageIdentifier }}}},[_vm._v("\n      "+_vm._s(_vm.$t('boxes.visitors.showMap'))+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"list list--striped"},[_c('li',{staticClass:"list__item list__title"},[_c('span',[_vm._v(_vm._s(_vm.$t('emailsList.emailColumn')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('emailsList.dateColumn')))])]),_vm._v(" "),_vm._l((_vm.emails),function(email){return _c('li',{key:email.id,staticClass:"list__item"},[_c('span',[_vm._v(_vm._s(email.subscription_email))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.parsedDate(email.created_at)))])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfPages > 1),expression:"numberOfPages > 1"}],staticClass:"pagination-cont"},[_c('div',{staticClass:"pagination"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage !== 1),expression:"currentPage !== 1"}],staticClass:"pagination__item",on:{"click":function($event){_vm.getEmailsOfPage(_vm.currentPage - 1)}}},[_vm._v("«")]),_vm._v(" "),_vm._l((_vm.numberOfPages),function(page){return _c('a',{key:page,staticClass:"pagination__item",class:{ 'active' : _vm.currentPage == page },on:{"click":function($event){_vm.getEmailsOfPage(page)}}},[_vm._v("\n        "+_vm._s(page)+"\n      ")])}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage !== _vm.numberOfPages),expression:"currentPage !== numberOfPages"}],staticClass:"pagination__item",on:{"click":function($event){_vm.getEmailsOfPage(_vm.currentPage + 1)}}},[_vm._v("»")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"clearfix"},_vm._l((_vm.chart.types),function(chartType){return _c('span',{key:chartType.type,staticClass:"pulled-right"},[_c('label',{staticClass:"checkbox",attrs:{"for":chartType.type}},[_c('input',{attrs:{"type":"checkbox","id":chartType.type},domProps:{"checked":chartType.visible},on:{"click":function($event){_vm.changeTypeVisibility(chartType.type)}}}),_vm._v(" "),_c('span',{style:({ background: chartType.color })}),_vm._v("\n        "+_vm._s(_vm.$t(("boxes." + (chartType.type) + ".title")))+"\n      ")])])})),_vm._v(" "),_c('div',{attrs:{"id":"c3-chart"}}),_vm._v(" "),_c('p',{staticClass:"info-text"},[_vm._v(_vm._s(_vm.$t('analytics.info.cacheDelay')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-loading-container"},[_c('hot-loading',{ref:"globalLoading",staticClass:"global-loading"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitle"},[_c('li',{staticClass:"kp-list-item dropdown",attrs:{"klickart-folder-item-type":"klickart","role":"tabpanel"}},[_c('div',{staticClass:"kp-folder-name"},[_c('span',[_vm._v(_vm._s(_vm.pageName))])]),_vm._v(" "),_c('div',{staticClass:"kp-folder-updatedate"},[_vm._v(_vm._s(_vm.lastEditedAt))]),_vm._v(" "),_c('span',{staticClass:"kp-select-open"},[_c('a',{attrs:{"href":_vm.editorUrl}},[_c('i',{staticClass:"icon-kp-edit"}),_vm._v(_vm._s(_vm.$t('analytics.header.subtitle.edit').toUpperCase())+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheGlobalLoading')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheGlobalLoading')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__search"},[_c('input',{staticClass:"input mobile-full",attrs:{"type":"text","placeholder":_vm.$t('locations.searchPlaceholder')},on:{"input":_vm.searchLocations}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading__icon"},[_c('div',{staticClass:"loading__fire"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 109.8 151.4"}},[_c('path',{attrs:{"d":"M109.7 96.6c.7-13.5-3.9-35.6-15.3-53.6-.3-.5-.8-.3-.7.2.8 2.8.9 7.7-3.4 7.4-7.8-.5.3-17.1-16.8-28.6-.2-.1-.4-.1-.5 0-.1.1-.1.3 0 .4 1.2 2.2 1.9 9.1-.8 11.5-2.2 1.9-6.1 1.4-10-4.8-6.4-10.4-4-21.5.4-28.4.3-.6-.2-.8-.6-.7-23.4 7.8-28.1 35.4-33.1 45.4-.8 1.7-1.6 2.6-3 2.5-4.3-.3-1.2-9.4.3-12.6.1-.2 0-.4-.1-.5-.1-.1-.3 0-.4.1C13.5 47.5 2.6 69 .5 88.9c.1-.5-.2 1.6-.3 3.2 0 .6-.1 1.2-.1 1.8-.1.8-.1 1.5-.1 2.3-.2 30.3 24.2 55 54.6 55.2 30.2.2 54.9-24.1 55.2-54.3 0-.2-.1-.4-.1-.5zm-55 25.4c-14-.1-25.3-11.6-25.2-25.7.1-14 11.6-25.3 25.7-25.2 14 .1 25.3 11.6 25.2 25.6-.2 14.2-11.7 25.5-25.7 25.3z"}})])]),_vm._v(" "),_c('div',{staticClass:"loading__activity"})]),_vm._v(" "),_c('span',{staticClass:"loading__title"},[_vm._v(" "+_vm._s(_vm.$t('loading.title'))+" ")]),_vm._v(" "),_c('span',{staticClass:"loading__subtitle"},[_vm._v(" "+_vm._s(_vm.$t('loading.subtitle'))+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb--small"},[_c('visitors'),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-xs-12"},[_c('div',{staticClass:"mb--small"},[_c('average-time')],1),_vm._v(" "),_c('conversions')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheGlobalLoading')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('klickart-analytics-header'),_vm._v(" "),_c('metrics')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box--purple"},[_c('h2',{staticClass:"box__title"},[_vm._v(_vm._s(_vm.$t('boxes.conversions.title')))]),_vm._v(" "),_c('ul',{staticClass:"list mb--small collumns--bordered"},_vm._l((_vm.visitors.clicks),function(click){return _c('li',{key:click.identifier,staticClass:"list__item "},[_c('h3',{staticClass:"list__title"},[_vm._v(_vm._s(_vm.$t('boxes.conversions.linkIdentifier', { identifier: click.identifier })))]),_vm._v(" "),_c('div',{staticClass:"text-nowrap"},[_vm._v("\n        "+_vm._s(click.conversions)+"\n        "),_c('span',{staticClass:"fz--small"},[_vm._v(_vm._s(click.percentage)+"%")])])])})),_vm._v(" "),_c('ul',{staticClass:"list mb--small"},[_c('li',{staticClass:"list__item"},[_c('h3',{staticClass:"list__title"},[_vm._v(_vm._s(_vm.$t('boxes.conversions.subscriptionIdentifier')))]),_vm._v(" "),_c('div',{staticClass:"text-nowrap"},[_vm._v("\n        "+_vm._s(_vm.visitors.registered_emails)+"\n        "),_c('span',{staticClass:"fz--small"},[_vm._v(_vm._s(_vm.visitors.registeredEmailsPercentage)+"%")])])])]),_vm._v(" "),_c('router-link',{staticClass:"button button--small--purple",attrs:{"to":{ name: 'EmailList', params: { locale: _vm.i18n.locale, slug: _vm.$route.params.pageIdentifier }}}},[_vm._v("\n    "+_vm._s(_vm.$t('boxes.conversions.showEmails'))+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitle"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"map",attrs:{"id":"map"}}),_vm._v(" "),_c('div',{ref:"pointInfo"},[_c('v-popover',{attrs:{"trigger":"manual","offset":"16","placement":"top","open":_vm.pointInfo.open}},[_c('template',{slot:"popover"},[_c('p',{staticClass:"popover-content popover-content--dark-blue"},[_vm._v(" "+_vm._s(_vm.pointInfo.name))]),_vm._v(" "),_c('p',{staticClass:"popover-content"},[_vm._v(" "+_vm._s(_vm.pointInfo.data)+" ")])])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('klickart-analytics-header',{attrs:{"breadcrumb":_vm.$t('locations.title')}}),_vm._v(" "),_c('div',{staticClass:"container no-padding"},[_c('div',{staticClass:"box no-padding"},[(_vm.dataLoaded)?_c('locations-map'):_vm._e(),_vm._v(" "),_c('header',{staticClass:"clearfix p-large"},[_c('span',{staticClass:"fz--medium pt--xsmall pulled-left"},[_c('span',{staticClass:"icon-kp-location-marker"}),_vm._v("\n          "+_vm._s(_vm.$tc('locations.visitors', _vm.total.visits, { count: _vm.total.visits }))+"\n          "),(_vm.total.visits > 0)?_c('span',[_vm._v("\n            "+_vm._s(_vm.$tc('locations.cities', _vm.total.cities, { count: _vm.total.cities }))+"\n            "+_vm._s(_vm.$tc('locations.countries', _vm.total.countries, { count: _vm.total.countries }))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pulled-right"},[_c('input-search')],1)]),_vm._v(" "),(_vm.total.visits > 0)?_c('list'):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box--red"},[_c('h2',{staticClass:"box__title"},[_vm._v(_vm._s(_vm.$t('boxes.duration.title')))]),_vm._v(" "),_c('span',{staticClass:"fz--large"},[_vm._v(_vm._s(_vm.visitors.averageTimeElapsed))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1498:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheGlobalLoading_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a037faa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheGlobalLoading_vue__ = __webpack_require__(1477);
function injectStyle (ssrContext) {
  __webpack_require__(1191)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a037faa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheGlobalLoading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a037faa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheGlobalLoading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_rebrand__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tokenRequest__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_tokenStrategies_tokenStrategyFactory__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authService__ = __webpack_require__(57);




var _this = this;






var PAGE_MANAGER_URL = __WEBPACK_IMPORTED_MODULE_3__config_rebrand__["a" /* default */].urls.PAGE_MANAGER_URL;

var casPath = 'v1/api/tokens';
var jwtPath = 'users/token/';
var tokenPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__auth_authService__["b" /* casEnabled */])() ? casPath : jwtPath;

/* harmony default export */ __webpack_exports__["a"] = (function (axiosInstance) {
  return function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(error) {
      var tokenRequest, config, response, token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tokenRequest = new __WEBPACK_IMPORTED_MODULE_4__tokenRequest__["a" /* default */]();

              if (error.response) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error));

            case 3:
              config = error.config, response = error.response;

              if (!(response.status !== 401)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error));

            case 6:
              if (!(config.tokenType === 'cas')) {
                _context.next = 12;
                break;
              }

              if (config.updateToken) {
                __WEBPACK_IMPORTED_MODULE_6__auth_authService__["d" /* bootstrap */].logout();
              }

              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_6__auth_authService__["d" /* bootstrap */].signinSilent();

            case 10:

              config.updateToken = true;

              return _context.abrupt('return', axiosInstance(config));

            case 12:
              if (!(response.status === 401)) {
                _context.next = 23;
                break;
              }

              if (!(config.url === tokenPath || config.updateToken)) {
                _context.next = 17;
                break;
              }

              window.location.href = PAGE_MANAGER_URL;
              _context.next = 23;
              break;

            case 17:
              _context.next = 19;
              return tokenRequest.token();

            case 19:
              token = __WEBPACK_IMPORTED_MODULE_5__auth_tokenStrategies_tokenStrategyFactory__["a" /* default */].getTokenStrategy('jwt').getToken();


              config.updateToken = true;
              config.headers.Authorization = 'Bearer ' + token;

              return _context.abrupt('return', axiosInstance(config));

            case 23:
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error));

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(785);







var Page = function (_API) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Page, _API);

  function Page() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Page);

    config.path = 'v1/pages';

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Page.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Page)).call(this, config));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Page, [{
    key: 'metrics',
    value: function metrics(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get(pageIdentifier + '/metrics', params);
    }
  }, {
    key: 'emails',
    value: function emails(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get(pageIdentifier + '/emails', params);
    }
  }, {
    key: 'exportEmails',
    value: function exportEmails(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get(pageIdentifier + '/emails/export', params);
    }
  }, {
    key: 'chartData',
    value: function chartData(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get(pageIdentifier + '/metrics/charts', params);
    }
  }, {
    key: 'locations',
    value: function locations(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get(pageIdentifier + '/metrics/locations', params);
    }
  }, {
    key: 'locationCoordinates',
    value: function locationCoordinates(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get(pageIdentifier + '/metrics/locations/coordinates', params);
    }
  }]);

  return Page;
}(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KlickartAnalyticsHeader_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d42430_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KlickartAnalyticsHeader_vue__ = __webpack_require__(1468);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KlickartAnalyticsHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d42430_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KlickartAnalyticsHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__watcher__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(304);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_3__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  var whitelist = ['Auth', 'Logout'];

  if (whitelist.includes(to.name)) {
    return next();
  }

  return next();
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__watcher__["a" /* default */])(router, __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Auth_store__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_Emails_store__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_Metrics_store__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_Locations_store__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__screens_Status_store__ = __webpack_require__(780);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var debug = "production" !== 'production' || "production" !== 'staging';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__screens_Auth_store__["a" /* default */],
    emails: __WEBPACK_IMPORTED_MODULE_3__screens_Emails_store__["a" /* default */],
    metrics: __WEBPACK_IMPORTED_MODULE_4__screens_Metrics_store__["a" /* default */],
    locations: __WEBPACK_IMPORTED_MODULE_5__screens_Locations_store__["a" /* default */],
    status: __WEBPACK_IMPORTED_MODULE_6__screens_Status_store__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_authService__ = __webpack_require__(57);




var CASTokenStrategy = function () {
  function CASTokenStrategy() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CASTokenStrategy);

    this.localStorageKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__auth_authService__["a" /* surrogateEnabled */])() ? 'surrogate-id-token' : 'cas-id-token';
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CASTokenStrategy, [{
    key: 'getToken',
    value: function getToken() {
      return localStorage.getItem(this.localStorageKey) || undefined;
    }
  }, {
    key: 'setToken',
    value: function setToken(token) {
      localStorage.setItem(this.localStorageKey, token);
    }
  }, {
    key: 'removeToken',
    value: function removeToken() {
      localStorage.removeItem(this.localStorageKey);
    }
  }]);

  return CASTokenStrategy;
}();

/* harmony default export */ __webpack_exports__["a"] = (CASTokenStrategy);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__genericCookieStrategy__ = __webpack_require__(319);







var ColaboratorTokenStrategy = function (_GenericCookieStrateg) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ColaboratorTokenStrategy, _GenericCookieStrateg);

  function ColaboratorTokenStrategy() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColaboratorTokenStrategy);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColaboratorTokenStrategy.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColaboratorTokenStrategy)).call(this, 'integrationBWCentral'));

    var cookieApiWithoutConverter = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.withConverter({
      read: function read(value, name) {
        if (name === 'integrationBWCentral') {
          return value;
        }

        return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.converter.read(value, name);
      }
    });
    _this.setCookieApi(cookieApiWithoutConverter);
    return _this;
  }

  return ColaboratorTokenStrategy;
}(__WEBPACK_IMPORTED_MODULE_5__genericCookieStrategy__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ColaboratorTokenStrategy);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);




var GenericCookieStrategy = function () {
  function GenericCookieStrategy(cookieName) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GenericCookieStrategy);

    this.cookieName = cookieName;
    this.cookieApi = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GenericCookieStrategy, [{
    key: 'getToken',
    value: function getToken() {
      return this.cookieApi.get(this.cookieName);
    }
  }, {
    key: 'setToken',
    value: function setToken(token) {
      this.cookieApi.set(this.cookieName, token);
    }
  }, {
    key: 'removeToken',
    value: function removeToken() {
      this.cookieApi.remove(this.cookieName);
    }
  }, {
    key: 'setCookieApi',
    value: function setCookieApi(cookieApi) {
      this.cookieApi = cookieApi;
    }
  }]);

  return GenericCookieStrategy;
}();

/* harmony default export */ __webpack_exports__["a"] = (GenericCookieStrategy);

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__genericCookieStrategy__ = __webpack_require__(319);






var JWTTokenStrategy = function (_GenericCookieStrateg) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(JWTTokenStrategy, _GenericCookieStrateg);

  function JWTTokenStrategy() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, JWTTokenStrategy);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (JWTTokenStrategy.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(JWTTokenStrategy)).call(this, 'user-auth-token'));
  }

  return JWTTokenStrategy;
}(__WEBPACK_IMPORTED_MODULE_4__genericCookieStrategy__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (JWTTokenStrategy);

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var metrics = {};

metrics.percentage = function (value, total) {
  if (total === 0) {
    return 0;
  }
  return (value / total * 100).toFixed(1);
};

/* harmony default export */ __webpack_exports__["a"] = (metrics);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LOCALE_KEY: 'klickpages_locale',
  DEFAULT_LOCALE: 'pt-BR'
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {};

types.EMAIL_LIST_SET_LIST = 'EMAIL_LIST_SET_LIST';
types.EMAIL_LIST_SET_PAGE = 'EMAIL_LIST_SET_PAGE';
types.EMAIL_LIST_SET_SLUG = 'EMAIL_LIST_SET_SLUG';

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {};

types.LOCATIONS_SET_PAGE = 'LOCATIONS_SET_PAGE';
types.LOCATIONS_SET_LIST = 'LOCATIONS_SET_LIST';
types.LOCATIONS_SET_COORDINATES = 'LOCATIONS_SET_COORDINATES';
types.LOCATIONS_SET_PAGEIDENTIFER = 'LOCATIONS_SET_PAGEIDENTIFER';

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {};

types.GET_METRICS = 'GET_METRICS';

types.SET_CHART_DATA = 'SET_CHART_DATA';
types.RESET_CHART_DATA = 'RESET_CHART_DATA';
types.CHANGE_CHART_TYPE_VISIBILITY = 'CHANGE_CHART_TYPE_VISIBILITY';

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  NOT_FOUND: 'notFound',
  UNPROCESSABLE_ENTITY: 'unprocessableEntity',
  ACCEPTED: 'accepted',
  OK: 'ok'
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {};

types.SET_GLOBAL_RESPONSE_STATUS = 'SET_GLOBAL_RESPONSE_STATUS';

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instance__ = __webpack_require__(790);





var Klickart = function () {
  function Klickart() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Klickart);

    this.path = config.path;
    this.axios = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instance__["a" /* default */])();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Klickart, [{
    key: 'post',
    value: function post() {
      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments[1];
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.axios.post(this.path + '/' + resource, data, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config));
    }
  }, {
    key: 'get',
    value: function get() {
      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.axios.get(this.path + '/' + resource, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config));
    }
  }]);

  return Klickart;
}();

/* harmony default export */ __webpack_exports__["a"] = (Klickart);

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jwt_decode__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__klickart__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_tokenStrategies_tokenStrategyFactory__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_authService__ = __webpack_require__(57);












var casPath = 'v1/api/tokens';
var jwtPath = 'users/token';

var TokenRequest = function (_Klickart) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TokenRequest, _Klickart);

  function TokenRequest() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TokenRequest);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TokenRequest.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TokenRequest)).call(this, config));

    _this.updatePathAndHeaders();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TokenRequest, [{
    key: 'updatePathAndHeaders',
    value: function updatePathAndHeaders() {
      this.path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__auth_authService__["b" /* casEnabled */])() ? casPath : jwtPath;
      this.headers = TokenRequest.getHeaders();
    }
  }, {
    key: 'token',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var body, config, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                body = TokenRequest.getBody();
                config = { headers: this.headers };
                _context.next = 4;
                return this.post('', body, config);

              case 4:
                response = _context.sent;

                __WEBPACK_IMPORTED_MODULE_9__auth_tokenStrategies_tokenStrategyFactory__["a" /* default */].getTokenStrategy('jwt').setToken(response.data.token);

                return _context.abrupt('return', response.data.token);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function token() {
        return _ref.apply(this, arguments);
      }

      return token;
    }()
  }, {
    key: 'decodeToken',
    value: function decodeToken(token) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_jwt_decode__["a" /* default */])(token);
    }
  }], [{
    key: 'getHeaders',
    value: function getHeaders() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__auth_authService__["b" /* casEnabled */])()) {
        var tokenName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__auth_authService__["c" /* isColaborator */])() ? 'colaborator' : 'cas';

        return {
          Authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_9__auth_tokenStrategies_tokenStrategyFactory__["a" /* default */].getTokenStrategy(tokenName).getToken(),
          Accept: 'application/json'
        };
      }
      return {};
    }
  }, {
    key: 'getBody',
    value: function getBody() {
      var REQUEST_BODY = { application: 'klickart-analytics', token_kind: 'jwt' };
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__auth_authService__["b" /* casEnabled */])() ? null : REQUEST_BODY;
    }
  }]);

  return TokenRequest;
}(__WEBPACK_IMPORTED_MODULE_8__klickart__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TokenRequest);

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request_tokenRequest__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_authService__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_tokenStrategies_casTokenStrategy__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_Layout_components_TheGlobalLoading__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_tokenStrategies_tokenStrategyFactory__ = __webpack_require__(123);


//
//
//
//
//
//
//
//







var tokenRequest = new __WEBPACK_IMPORTED_MODULE_2__services_request_tokenRequest__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { TheGlobalLoading: __WEBPACK_IMPORTED_MODULE_5__screens_Layout_components_TheGlobalLoading__["a" /* default */] },
  data: function data() {
    return {
      publicRoutes: ['Logout', 'Surrogate'],
      componentReadyToRender: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.publicRoutes.includes(_this.$route.name)) {
                _context.next = 5;
                break;
              }

              if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth_authService__["b" /* casEnabled */])()) {
                __WEBPACK_IMPORTED_MODULE_3__auth_authService__["d" /* bootstrap */].stop();
              }
              _this.componentReadyToRender = true;
              _context.next = 8;
              break;

            case 5:
              _context.next = 7;
              return _this.setupAuthentication();

            case 7:

              _this.setGoogleAnalyticsUser();

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setupAuthentication: function setupAuthentication() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var bootstrapConfig;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth_authService__["b" /* casEnabled */])()) {
                  _context3.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3__auth_authService__["d" /* bootstrap */].subscribe({
                  next: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(casUser) {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              new __WEBPACK_IMPORTED_MODULE_4__auth_tokenStrategies_casTokenStrategy__["a" /* default */]().setToken(casUser.id_token);

                              _context2.next = 3;
                              return _this2.handleToken();

                            case 3:

                              _this2.componentReadyToRender = true;

                            case 4:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2);
                    }));

                    return function next(_x) {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });

                bootstrapConfig = { appName: 'klickart-analytics-client' };

                __WEBPACK_IMPORTED_MODULE_3__auth_authService__["d" /* bootstrap */].start(bootstrapConfig);
                _context3.next = 9;
                break;

              case 6:
                _context3.next = 8;
                return _this2.handleToken();

              case 8:

                _this2.componentReadyToRender = true;

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    handleToken: function handleToken() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return tokenRequest.token();

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    setGoogleAnalyticsUser: function setGoogleAnalyticsUser() {
      var token = __WEBPACK_IMPORTED_MODULE_6__auth_tokenStrategies_tokenStrategyFactory__["a" /* default */].getTokenStrategy('jwt').getToken();
      var decodedToken = tokenRequest.decodeToken(token);

      this.$ga.set('userId', decodedToken.userProfile.apiKey);
      this.$ga.page(this.$router);
    }
  }
});

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_Layout_components_KlickartAnalyticsHeader__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Emails_components_List__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_Emails_components_Search__ = __webpack_require__(1449);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.resetEmailRequestParams();
    this.getCapturedEmails(this.$route.params.pageIdentifier);
  },

  components: {
    KlickartAnalyticsHeader: __WEBPACK_IMPORTED_MODULE_1__screens_Layout_components_KlickartAnalyticsHeader__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_2__screens_Emails_components_List__["a" /* default */],
    InputSearch: __WEBPACK_IMPORTED_MODULE_3__screens_Emails_components_Search__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    numberOfEmails: 'emails/numberOfEmails'
  }),
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])({
    resetEmailRequestParams: 'emails/resetEmailRequestParams',
    getCapturedEmails: 'emails/getCapturedEmails',
    exportEmails: 'emails/exportEmails'
  })
});

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_Layout_components_KlickartAnalyticsHeader__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Locations_components_Map__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_Locations_components_List__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_Locations_components_Search__ = __webpack_require__(1454);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var _this = this;

    this.getLocations(this.$route.params.pageIdentifier).then(function () {
      _this.dataLoaded = true;
    });
  },

  components: {
    KlickartAnalyticsHeader: __WEBPACK_IMPORTED_MODULE_1__screens_Layout_components_KlickartAnalyticsHeader__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_3__screens_Locations_components_List__["a" /* default */],
    InputSearch: __WEBPACK_IMPORTED_MODULE_4__screens_Locations_components_Search__["a" /* default */],
    LocationsMap: __WEBPACK_IMPORTED_MODULE_2__screens_Locations_components_Map__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    total: 'locations/total'
  }),
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])({
    getLocations: 'locations/getLocations'
  })
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_Layout_components_KlickartAnalyticsHeader__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_Metrics_components_Main__ = __webpack_require__(1455);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    KlickartAnalyticsHeader: __WEBPACK_IMPORTED_MODULE_0__screens_Layout_components_KlickartAnalyticsHeader__["a" /* default */],
    Metrics: __WEBPACK_IMPORTED_MODULE_1__screens_Metrics_components_Main__["a" /* default */]
  }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_rebrand__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_components_TheGlobalLoading__ = __webpack_require__(204);


//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuthLogout',
  components: { TheGlobalLoading: __WEBPACK_IMPORTED_MODULE_3__Layout_components_TheGlobalLoading__["a" /* default */] },
  data: function data() {
    return {
      logoutUrl: __WEBPACK_IMPORTED_MODULE_2__config_rebrand__["a" /* default */].urls.KLICKART_URL + '/crossapp/logout'
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.location.href = _this.logoutUrl;

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Auth',
  created: function created() {
    this.$store.dispatch('auth/init');
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_components_TheGlobalLoading__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_authService__ = __webpack_require__(57);


//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuthStartLogout',
  components: { TheGlobalLoading: __WEBPACK_IMPORTED_MODULE_2__Layout_components_TheGlobalLoading__["a" /* default */] },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth_authService__["b" /* casEnabled */])()) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__auth_authService__["d" /* bootstrap */].logout();

            case 3:
              _context.next = 6;
              break;

            case 5:
              _this.$router.push({ path: '/auth/logout' });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_rebrand__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Layout_components_TheGlobalLoading__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_tokenStrategies_jwtTokenStrategy__ = __webpack_require__(320);
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuthSurrogate',
  components: { TheGlobalLoading: __WEBPACK_IMPORTED_MODULE_1__Layout_components_TheGlobalLoading__["a" /* default */] },
  data: function data() {
    return {
      appUrl: "https://analytics.pages.hotmart.com",
      pageManagerUrl: __WEBPACK_IMPORTED_MODULE_0__config_rebrand__["a" /* default */].urls.PAGE_MANAGER_URL
    };
  },

  methods: {
    redirectToSurrogateSession: function redirectToSurrogateSession() {
      var redirectTo = this.$route.query.redirect_to;

      window.location.href = this.isValidRedirect(redirectTo) ? this.appUrl + '/' + redirectTo : this.pageManagerUrl;
    },
    isValidRedirect: function isValidRedirect(redirect) {
      if (redirect === null || redirect === undefined || redirect === '') {
        return false;
      }

      return true;
    },
    removeJWTToken: function removeJWTToken() {
      var jwtToken = new __WEBPACK_IMPORTED_MODULE_2__auth_tokenStrategies_jwtTokenStrategy__["a" /* default */]();

      jwtToken.removeToken();
    }
  },
  created: function created() {
    this.removeJWTToken();

    sessionStorage.setItem('surrogate-enabled', 'true');

    this.redirectToSurrogateSession();
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_date__ = __webpack_require__(124);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    emails: 'emails/emailsList',
    numberOfPages: 'emails/numberOfPages',
    currentPage: 'emails/currentPage'
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    parsedDate: function parsedDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2__services_date__["a" /* default */].formatedDate(date, this.$t('date.dateAndTime'));
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getEmailsOfPage: 'emails/getEmailsOfPage'
  }))
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])({
    searchCapturedEmails: 'emails/searchCapturedEmails'
  })
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__subtitle_KlickartHeaderSubtitle__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subtitle_NewEditorHeaderSubtitle__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_rebrand__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    KlickartHeaderSubtitle: __WEBPACK_IMPORTED_MODULE_0__subtitle_KlickartHeaderSubtitle__["a" /* default */],
    NewEditorHeaderSubtitle: __WEBPACK_IMPORTED_MODULE_1__subtitle_NewEditorHeaderSubtitle__["a" /* default */]
  },
  data: function data() {
    return {
      klickartUrl: __WEBPACK_IMPORTED_MODULE_3__config_rebrand__["a" /* default */].urls.KLICKART_URL.replace('http:', 'https:'),
      menuOpen: false,
      isKlickartPage: !!Number(this.$route.params.pageIdentifier),
      i18n: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */]
    };
  },

  props: ['breadcrumb']
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheGlobalLoading'
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request_klickartPage__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(36);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      i18n: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */]
    };
  },
  mounted: function mounted() {
    var klickartPage = new __WEBPACK_IMPORTED_MODULE_0__services_request_klickartPage__["a" /* default */]();
    var subtitle = this.$el;

    klickartPage.page('' + this.$route.params.pageIdentifier).then(function (response) {
      var html = response.data;
      html = html.replace(/http:/g, 'https:');
      subtitle.innerHTML = html;
    });
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_date__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_request_editorApiPage__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_rebrand__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pageName: '',
      lastEditedAt: '',
      editorUrl: __WEBPACK_IMPORTED_MODULE_2__config_rebrand__["a" /* default */].urls.KLICKART_URL + '/crossapp/editor?redirect=' + __WEBPACK_IMPORTED_MODULE_2__config_rebrand__["a" /* default */].urls.EDITOR_URL + '/' + this.$route.params.pageIdentifier
    };
  },
  mounted: function mounted() {
    var _this = this;

    var editorApi = new __WEBPACK_IMPORTED_MODULE_1__services_request_editorApiPage__["a" /* default */]();

    editorApi.page('' + this.$route.params.pageIdentifier).then(function (response) {
      _this.pageName = response.data.name;
      _this.lastEditedAt = __WEBPACK_IMPORTED_MODULE_0__services_date__["a" /* default */].formatedDate(response.data.updatedAt, _this.$t('date.dateAndTime'));
    });
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    locations: 'locations/locations',
    numberOfPages: 'locations/numberOfPages',
    currentPage: 'locations/currentPage'
  }),
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])({
    getLocationsOfPage: 'locations/getLocationsOfPage'
  })
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_map_control__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_map__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_tooltip__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_Overlay__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_View__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_Map__ = __webpack_require__(625);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VPopover: __WEBPACK_IMPORTED_MODULE_4_v_tooltip__["a" /* VPopover */]
  },
  data: function data() {
    return {
      map: null,
      pointInfo: {
        name: null,
        data: null,
        element: null,
        open: false
      }
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    coordinates: 'locations/coordinates'
  }),
  mounted: function mounted() {
    var _this = this;

    this.getCoordinates().then(function () {
      _this.createMap();
      _this.addPopoverOnMap();
      _this.listenEvents();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    createMap: function createMap() {
      var baseMapLayer = __WEBPACK_IMPORTED_MODULE_3__services_map__["a" /* default */].createOpenStreetLayer();
      var featuresLayer = __WEBPACK_IMPORTED_MODULE_3__services_map__["a" /* default */].createVectorLayer(this.coordinates);
      var settings = __WEBPACK_IMPORTED_MODULE_3__services_map__["a" /* default */].settings();
      this.map = new __WEBPACK_IMPORTED_MODULE_7_ol_Map__["a" /* default */]({
        layers: [baseMapLayer, featuresLayer],
        target: 'map',
        view: new __WEBPACK_IMPORTED_MODULE_6_ol_View__["a" /* default */]({
          center: settings.center,
          zoom: settings.zoom,
          minZoom: settings.zoom,
          projection: settings.projection
        })
      });

      this.map.addControl(__WEBPACK_IMPORTED_MODULE_1__services_map_control__["a" /* default */].centerToUserLocation(this.map));
    },
    listenEvents: function listenEvents() {
      var _this2 = this;

      this.map.on('pointermove', function (event) {
        _this2.pointInfo.open = false;

        var pixel = _this2.map.getEventPixel(event.originalEvent);
        _this2.map.getViewport().style.cursor = _this2.map.hasFeatureAtPixel(pixel) ? 'pointer' : '';

        _this2.map.forEachFeatureAtPixel(pixel, _this2.showPointInfo, { hitTolerance: __WEBPACK_IMPORTED_MODULE_3__services_map__["a" /* default */].settings.clickMargin });
      });
    },
    addPopoverOnMap: function addPopoverOnMap() {
      this.pointInfo.element = new __WEBPACK_IMPORTED_MODULE_5_ol_Overlay__["a" /* default */]({ element: this.$refs.pointInfo, stopEvent: false });
      this.map.addOverlay(this.pointInfo.element);
    },
    showPointInfo: function showPointInfo(feature) {
      this.pointInfo.open = false;
      var coordinates = feature.getGeometry().getCoordinates();
      this.pointInfo.element.setPosition(coordinates);
      this.pointInfo.name = feature.get('name') || this.$t('locations.not_identified');
      this.pointInfo.data = feature.get('data');
      this.pointInfo.open = true;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    getCoordinates: 'locations/getCoordinates'
  }))
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])({
    searchLocations: 'locations/searchLocations'
  })
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_Metrics_components_metrics_Metrics__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_Metrics_components_charts_Chart__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__screens_Status_StatusMain__ = __webpack_require__(1462);



//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pageIdentifier: this.$route.params.pageIdentifier
    };
  },
  created: function created() {
    this.tryPageMetricsWhileProcessing();
  },

  components: {
    Metrics: __WEBPACK_IMPORTED_MODULE_4__screens_Metrics_components_metrics_Metrics__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_5__screens_Metrics_components_charts_Chart__["a" /* default */],
    GlobalResponseStatus: __WEBPACK_IMPORTED_MODULE_6__screens_Status_StatusMain__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getMetrics: 'metrics/get',
    retryMetrics: 'metrics/retry',
    defineGlobalStatusFromResponseStatus: 'status/defineFromResponseStatus'
  }), {
    tryPageMetricsWhileProcessing: function tryPageMetricsWhileProcessing() {
      var _this = this;

      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.getMetrics({ pageIdentifier: _this.pageIdentifier, filters: filters });

              case 2:
                response = _context2.sent;

                _this.defineGlobalStatusFromResponseStatus(response.status);

                if (_this.isStatusAccepted) {
                  setTimeout(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.tryPageMetricsWhileProcessing();

                          case 2:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  })), 5000);
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    retryPageMetrics: function retryPageMetrics() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.tryPageMetricsWhileProcessing({ retryPageMetrics: true });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  }),
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    isStatusOk: 'status/isOk',
    isStatusAccepted: 'status/isAccepted'
  })
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    visitors: 'metrics/visitors'
  })
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      i18n: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */]
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    visitors: 'metrics/visitors'
  })
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      i18n: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */]
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])({
    visitors: 'metrics/visitors'
  }),
  methods: {
    hasLocations: function hasLocations() {
      return this.visitors.locations && this.visitors.locations.length > 0;
    }
  }
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_klicknotify__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_klicknotify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_klicknotify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_date__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineChart__ = __webpack_require__(1460);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pageIdentifier: {
      type: String,
      require: true
    }
  },
  created: function created() {
    var _this = this;

    this.getChartData({ pageIdentifier: this.pageIdentifier, filters: this.filters }).then(function () {
      _this.loaded = true;
    });
  },

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_7__LineChart__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      datepickerLanguage: { en: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["en"], es: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["es"], 'pt-BR': __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["ptBR"] },
      i18n: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */],
      filters: {
        start: __WEBPACK_IMPORTED_MODULE_6__services_date__["a" /* default */].subtractDays(__WEBPACK_IMPORTED_MODULE_6__services_date__["a" /* default */].today(), 7),
        end: __WEBPACK_IMPORTED_MODULE_6__services_date__["a" /* default */].today(),
        granularity: 'day'
      },
      loaded: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    chart: 'metrics/chart'
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    filterChart: function filterChart() {
      if (__WEBPACK_IMPORTED_MODULE_6__services_date__["a" /* default */].isInvalidPeriod(this.filters.start, this.filters.end)) {
        __WEBPACK_IMPORTED_MODULE_2_klicknotify___default.a.error({ message: this.$t('chart.date.invalidPeriod'), autoHide: true });
        return;
      }
      this.filters.start = __WEBPACK_IMPORTED_MODULE_6__services_date__["a" /* default */].truncate(this.filters.start);
      this.filters.end = __WEBPACK_IMPORTED_MODULE_6__services_date__["a" /* default */].truncate(this.filters.end);
      this.getChartData({ pageIdentifier: this.pageIdentifier, filters: this.filters });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getChartData: 'metrics/getChartData'
  }))
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_c3__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_c3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_c3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_c3_c3_min_css__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_c3_c3_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_c3_c3_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    chart: 'metrics/chart'
  }),
  data: function data() {
    return {
      c3Chart: null
    };
  },

  methods: {
    updateChart: function updateChart() {
      if (!this.hasData()) {
        this.c3Chart.unload();
        return;
      }

      this.c3Chart.load({
        json: this.chart.data,
        keys: this.getKeys()
      });
    },
    changeTypeVisibility: function changeTypeVisibility(type) {
      this.c3Chart.toggle(type);
    },
    getKeys: function getKeys() {
      return this.hasData() ? this.chart.keys : { value: [] };
    },
    hasData: function hasData() {
      return this.chart.data.length > 0;
    }
  },
  mounted: function mounted() {
    this.c3Chart = __WEBPACK_IMPORTED_MODULE_0_c3___default.a.generate({
      bindto: '#c3-chart',
      data: {
        json: this.chart.data,
        keys: this.getKeys(),
        empty: {
          label: {
            text: this.$t('chart.noData')
          }
        }
      },
      color: {
        pattern: this.chart.colors
      },
      legend: { show: false },
      tooltip: { show: false },
      axis: {
        x: { type: 'category', show: true },
        y: { show: true }
      },
      grid: {
        x: { show: true },
        y: { show: true }
      }
    });
  },

  watch: {
    chart: {
      handler: 'updateChart',
      deep: true
    }
  },
  beforeDestroyed: function beforeDestroyed() {
    this.c3Chart = this.c3Chart.destroy();
  }
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_Metrics_components_boxes_Visitors__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_Metrics_components_boxes_AverageTime__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Metrics_components_boxes_Conversions__ = __webpack_require__(1457);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { pageIdentifier: this.$route.params.pageIdentifier };
  },

  components: {
    Visitors: __WEBPACK_IMPORTED_MODULE_0__screens_Metrics_components_boxes_Visitors__["a" /* default */],
    AverageTime: __WEBPACK_IMPORTED_MODULE_1__screens_Metrics_components_boxes_AverageTime__["a" /* default */],
    Conversions: __WEBPACK_IMPORTED_MODULE_2__screens_Metrics_components_boxes_Conversions__["a" /* default */]
  }
});

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Error__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_rebrand__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */],
    Error: __WEBPACK_IMPORTED_MODULE_3__components_Error__["a" /* default */]
  },
  data: function data() {
    return {
      i18n: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */],
      supportUrl: 'https://suporteklickpages.zendesk.com/hc/pt-br/requests/new',
      pagesUrl: __WEBPACK_IMPORTED_MODULE_4__config_rebrand__["a" /* default */].urls.KLICKART_URL.replace('http:', 'https:')
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isAccepted: 'status/isAccepted',
    isNotFound: 'status/isNotFound',
    isUnprocessableEntity: 'status/isUnprocessableEntity'
  }),
  methods: {
    redirectToSupport: function redirectToSupport() {
      window.location = this.supportUrl;
    },
    redirectToPages: function redirectToPages() {
      window.location = this.pagesUrl;
    },
    primaryErrorButtonFunction: function primaryErrorButtonFunction() {
      this.$emit('primaryErrorButtonFunction');
    }
  }
});

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    errorTitle: {
      type: String,
      require: false
    },
    errorSubtitle: {
      type: String,
      require: false
    },
    displayPrimaryErrorButton: {
      type: Boolean,
      require: true
    },
    primaryErrorButtonText: {
      type: String,
      require: false
    },
    displaySecondaryErrorButton: {
      type: Boolean,
      require: true
    },
    secondaryErrorButtonText: {
      type: String,
      require: false
    }
  },
  data: function data() {
    return {
      i18n: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */]
    };
  },

  methods: {
    primaryErrorButtonFunction: function primaryErrorButtonFunction() {
      this.$emit('primaryErrorButtonFunction');
    },
    secondaryErrorButtonFunction: function secondaryErrorButtonFunction() {
      this.$emit('secondaryErrorButtonFunction');
    }
  }
});

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      i18n: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cookie__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_url__ = __webpack_require__(755);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var getLocale = function getLocale() {
  var urlLocale = __WEBPACK_IMPORTED_MODULE_5__helpers_url__["a" /* default */].getLocale(window.location.pathname);
  var cookieLocale = __WEBPACK_IMPORTED_MODULE_3__cookie__["a" /* default */].locale.get();

  return cookieLocale || urlLocale || __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].DEFAULT_LOCALE;
};

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: getLocale(),
  messages: __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isDomainRebrand = window.location.hostname === "analytics.pages.hotmart.com";

/* harmony default export */ __webpack_exports__["a"] = ({
  urls: {
    API_ENDPOINT: isDomainRebrand ? "https://analytics-api.pages.hotmart.com" : "https://analytics-api.eks.klickpages.com.br",
    KLICKART_URL: isDomainRebrand ? "https://art.pages.hotmart.com" : "https://art.klickpages.com.br",
    KLICKART_AUTH_URI: isDomainRebrand ? "https://art.pages.hotmart.com/crossapp/analytics" : "https://art.klickpages.com.br/crossapp/analytics",
    EDITOR_API_ENDPOINT: isDomainRebrand ? "https://pages-editor-api.pages.hotmart.com" : "https://pages-editor-api.eks.klickpages.com.br",
    EDITOR_URL: isDomainRebrand ? "https://editor.pages.hotmart.com" : "https://editor.klickpages.com.br",
    PAGE_MANAGER_URL: isDomainRebrand ? "https://pages.hotmart.com" : "https://pages.klickpages.com.br"
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return bootstrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return casEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return surrogateEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isColaborator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hotmart_cas_js__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hotmart_cas_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hotmart_cas_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hotmart_cas_js_dist_auth_service__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hotmart_cas_js_dist_auth_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__hotmart_cas_js_dist_auth_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tokenStrategies_colaboratorTokenStrategy__ = __webpack_require__(318);




var surrogateEnabled = function surrogateEnabled() {
  return sessionStorage.getItem('surrogate-enabled') === 'true';
};

var CAS_USER_STORE = surrogateEnabled() ? __WEBPACK_IMPORTED_MODULE_1__hotmart_cas_js_dist_auth_service__["PossibleStorages"].sessionStorage : __WEBPACK_IMPORTED_MODULE_1__hotmart_cas_js_dist_auth_service__["PossibleStorages"].localStorage;

var CAS_AUTHORITY = surrogateEnabled() ? "https://sso-surrogate.hotmart.com" : "https://sso.hotmart.com";

var authService = new __WEBPACK_IMPORTED_MODULE_0__hotmart_cas_js___default.a({
  env:  true ? 'production' : 'development',
  client_id: "9c54b758-db9e-4fd6-adc0-4445096ebde2",
  authority: CAS_AUTHORITY + '/oidc',
  storeToUse: CAS_USER_STORE,
  scope: 'openid profile email authorities user'
});

var bootstrapConfig = { appName: 'klickart-analytics-client' };
var bootstrap = new __WEBPACK_IMPORTED_MODULE_0__hotmart_cas_js__["Bootstrap"](authService, bootstrapConfig);

var casEnabled = function casEnabled() {
  var casAuthEnabled = "true" === 'true';

  return casAuthEnabled;
};

var isColaborator = function isColaborator() {
  if (false) {
    return false;
  }

  var colaboratorTokenStrategy = new __WEBPACK_IMPORTED_MODULE_2__tokenStrategies_colaboratorTokenStrategy__["a" /* default */]();
  var colaboratorToken = colaboratorTokenStrategy.getToken();

  return colaboratorToken !== undefined && colaboratorToken !== null;
};


/* unused harmony default export */ var _unused_webpack_default_export = (authService);

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_authService__ = __webpack_require__(57);


var isDomainRebrand = window.location.hostname === "analytics.pages.hotmart.com";
var storageKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__auth_authService__["a" /* surrogateEnabled */])() ? 'surrogate-id-token' : 'cas-id-token';

/* harmony default export */ __webpack_exports__["a"] = ({
  urls: {
    KLICKART_URL: isDomainRebrand ? "https://art.pages.hotmart.com" : "https://art.klickpages.com.br",
    UPGRADE_USER_KLICK: "https://klickpages.com.br/monteseuplano/",
    UPGRADE_USER_EXTENSION: "https://extensions.hotmart.com/salespage",
    START_HERE_URL: "https://extensoes.hotmart.com/comece-por-aqui?utm_source=botao_barralateral&utm_medium=pages&utm_campaign=botao_barralateral_pages",
    HELP_CENTER_URL: "https://suporteklickpages.zendesk.com/hc/pt-br",
    EMAIL_MARKETING_BRAND: "Hotmart Send",
    PAGE_MANAGER_URL: isDomainRebrand ? "https://pages.hotmart.com" : "https://pages.klickpages.com.br",
    FREE_PLAN_MERLIN_ID: "fc30776a-80a5-4a05-bfa6-14b68f7e23ab",
    PAYED_PLAN_MERLIN_ID: "3794fb4d-a261-46b8-901a-ba7789b7ce74",
    ZENDESK_MESSENGER_ID: "2a6d54b2-2623-42f7-bf4a-c817b545d77c",
    COOKIE_DOMAIN: isDomainRebrand ? "hotmart.com" : "klickpages.com.br",
    SEND_URL: isDomainRebrand ? "https://send.hotmart.com" : "https://send.klickpages.com.br",
    CAS_LOGOUT_URL: "https://analytics.pages.hotmart.com/auth/start-logout"
  },
  casToken: {
    enabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__auth_authService__["b" /* casEnabled */])(),
    storageKey: storageKey,
    isColaborator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__auth_authService__["c" /* isColaborator */])(),
    colaboratorStorageKey: 'integrationBWCentral'
  }
});

/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004634ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1465);
function injectStyle (ssrContext) {
  __webpack_require__(1189)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004634ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 735:
/***/ (function(module, exports) {

module.exports = {"_from":"@hotmart/event-agent-js@^1.1.2","_id":"@hotmart/event-agent-js@1.1.2","_inBundle":false,"_integrity":"sha512-K2Rtdb8Y3Pb5LsR6I8Q4YhGWbaEj/qRQNMO5xP8KeZDsdjTbvM0mMI/Jm6J4GRJOJjDakwIOnU8uRnwuZTIU8g==","_location":"/@hotmart/event-agent-js","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"@hotmart/event-agent-js@^1.1.2","name":"@hotmart/event-agent-js","escapedName":"@hotmart%2fevent-agent-js","scope":"@hotmart","rawSpec":"^1.1.2","saveSpec":null,"fetchSpec":"^1.1.2"},"_requiredBy":["/@hotmart-org-ca/saas-pages-universal-navigator-2x","/@hotmart/cas-js"],"_resolved":"https://registry.npmjs.org/@hotmart/event-agent-js/-/event-agent-js-1.1.2.tgz","_shasum":"9d251eb7e3e3b054986e72034cbe55022dad9e66","_spec":"@hotmart/event-agent-js@^1.1.2","_where":"/opt/atlassian/pipelines/agent/build/lib/assets","author":{"name":"Raphael Monte"},"bugs":{"url":"https://github.com/Hotmart-Org/request/issues"},"bundleDependencies":false,"dependencies":{},"deprecated":false,"description":"```js npm install @hotmart/event-agent-js yarn add @hotmart/event-agent-js ```","devDependencies":{"@testing-library/jest-dom":"^4.2.3","@types/jest":"^24.0.23","@types/node":"^12.12.7","@typescript-eslint/eslint-plugin":"^2.7.0","@typescript-eslint/parser":"^2.7.0","eslint":"^6.6.0","eslint-plugin-jest":"^23.0.3","jest":"^24.9.0","ts-jest":"^24.1.0","ts-loader":"^6.2.1","typescript":"^3.7.2"},"homepage":"https://github.com/Hotmart-Org/request#readme","keywords":["event","agent","datahub"],"license":"ISC","main":"dist/index.js","name":"@hotmart/event-agent-js","repository":{"type":"git","url":"git+https://github.com/Hotmart-Org/request.git"},"scripts":{"build":"tsc","prepublishOnly":"npm install && npm run build"},"version":"1.1.2"}

/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_date__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(36);



var charts = {};
var types = ['visitors', 'conversions'];

charts.colors = ['#85bdd7', '#a99bc8'];

charts.getChartsTypes = function () {
  return types.map(function (type, index) {
    return { type: type, color: charts.colors[index], visible: true };
  });
};

charts.keys = {
  x: 'period',
  value: types
};

var getFormatByGranularity = function getFormatByGranularity(granularity) {
  return __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('chart.granularity.' + granularity + '.format');
};

charts.formatPeriod = function (period, granularity) {
  return __WEBPACK_IMPORTED_MODULE_0__services_date__["a" /* default */].formatedDate(period, getFormatByGranularity(granularity), granularity === 'day');
};

/* harmony default export */ __webpack_exports__["a"] = (charts);

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var file = {};
var fileElement = void 0;

var createFileElement = function createFileElement() {
  fileElement = document.createElement('a');
  document.body.appendChild(fileElement);
};

var removeFileElement = function removeFileElement() {
  document.body.removeChild(fileElement);
};

file.download = function (data, type, name) {
  createFileElement();
  fileElement.href = window.URL.createObjectURL(new Blob([data], { type: type }));
  fileElement.download = name;
  fileElement.click();

  removeFileElement();
};

/* harmony default export */ __webpack_exports__["a"] = (file);

/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var url = {};

var validLocales = ['en', 'es', 'pt-BR'];

var isLocaleValid = function isLocaleValid(locale) {
  return validLocales.includes(locale);
};

var getFirstPath = function getFirstPath(path) {
  var paths = path.split('/');
  var i = 0;

  while (!paths[i] && i < paths.length) {
    i += 1;
  }return paths[i];
};

url.getLocale = function (path) {
  var locale = getFirstPath(path);

  if (isLocaleValid(locale)) {
    return locale;
  }

  return null;
};

url.hasLocale = function (path) {
  return !!url.getLocale(path);
};

url.adjustTopBarLocale = function (html, pageIdentifier) {
  var newHtml = html;
  validLocales.forEach(function (locale) {
    newHtml = newHtml.replace('"/' + locale + '"', '"/' + locale + '/' + pageIdentifier + '"');
  });

  return newHtml;
};

/* harmony default export */ __webpack_exports__["a"] = (url);

/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(322);



var getLocale = function getLocale() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].LOCALE_KEY);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  locale: {
    get: getLocale
  }
});

/***/ }),

/***/ 757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__languages_es__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languages_enUs__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languages_ptBr__ = __webpack_require__(760);




/* harmony default export */ __webpack_exports__["a"] = ({
  es: __WEBPACK_IMPORTED_MODULE_0__languages_es__["a" /* default */],
  en: __WEBPACK_IMPORTED_MODULE_1__languages_enUs__["a" /* default */],
  'pt-BR': __WEBPACK_IMPORTED_MODULE_2__languages_ptBr__["a" /* default */]
});

/***/ }),

/***/ 758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  analytics: {
    header: {
      title: 'Metrics',
      back: 'Back to my pages',
      subtitle: {
        edit: 'Edit'
      }
    },
    info: {
      cacheDelay: '*Page metrics may take up to one day to be refreshed'
    }
  },
  boxes: {
    total: 'Total',
    conversions: {
      title: 'Conversions',
      conversionRate: 'Conversion Rate',
      showEmails: 'View captured emails',
      conversionType: 'Conversion identifier',
      subscriptionIdentifier: 'Registration on email form',
      linkIdentifier: 'Link {identifier}'
    },
    duration: {
      title: 'Average duration'
    },
    visitors: {
      title: 'Visitors',
      unique: 'Unique',
      local: 'Location',
      country: 'Country',
      visits: 'Visits',
      showMap: "View visitors' origin"
    }
  },
  date: {
    simpleFormat: 'MM/dd/yyyy',
    dateAndTime: 'MM/DD/YYYY hh:mm a',
    simpleFormatDash: 'MM-DD-YYYY'
  },
  emailsList: {
    title: 'Captured emails',
    emailColumn: 'Email address',
    dateColumn: 'Date',
    searchPlaceholder: 'Search address',
    capturedEmails: 'No captured emails | 1 email captured |  {count} emails captured',
    export: {
      button: 'Export',
      fileName: 'List of captured emails'
    }
  },
  pagination: {
    previous: 'Previous',
    next: 'Next'
  },
  chart: {
    period: 'Period',
    date: {
      from: 'From',
      to: 'to',
      invalidPeriod: 'The start date of the period must be before the final date. Please select another period of dates. '
    },
    filter: 'Filter and show chart',
    granularity: {
      hour: {
        label: 'Time',
        format: 'MM/DD [at] HH[h]'
      },
      day: {
        label: 'Day',
        format: 'MM/DD'
      }
    },
    noData: 'No data for the period'
  },
  locations: {
    title: "Visitors' origin",
    searchPlaceholder: 'Filter locale',
    visitors_percent: '% of visitors',
    visitors: 'No visitors | 1 visitor | {count} visitors',
    cities: 'from 1 city | from {count} cities',
    countries: 'in 1 country | in {count} countries',
    not_identified: 'Not identified'
  },
  notifications: {
    noNotifications: 'There are no new notifications.',
    unableLoad: 'We were unable to load notifications at this time.'
  },
  loading: {
    title: 'We are processing the action. Please wait while we load the data.',
    subtitle: 'The request may take a few minutes.'
  },
  error: {
    notFound: {
      title: 'We could not find this page`s metrics',
      buttons: {
        home: 'Go to home page'
      }
    },
    metricsProcess: {
      title: 'Something went wrong',
      subtitle: 'We were unable to load this page right now, but we are working to resolve the issue. Try again in a few minutes. If the problem persists, you can contact our Support.',
      buttons: {
        home: 'Try again',
        support: 'Contact support'
      }
    }
  }
});

/***/ }),

/***/ 759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  analytics: {
    header: {
      title: 'Métricas',
      back: 'Volver para mis páginas',
      subtitle: {
        edit: 'Editar'
      }
    },
    info: {
      cacheDelay: '*Las métricas de la página pueden tardar hasta un día en actualizarse'
    }
  },
  boxes: {
    total: 'Total',
    conversions: {
      title: 'Conversiones',
      conversionRate: 'Tasa de Conversión',
      showEmails: 'Ver e-mails capturados',
      conversionType: 'Identificador de la conversión',
      subscriptionIdentifier: 'Inscripción en el formulario de e-mail',
      linkIdentifier: 'Link {identifier}' },
    duration: {
      title: 'Duración media'
    },
    visitors: {
      title: 'Visitantes',
      unique: 'Únicos',
      local: 'Lugar',
      country: 'País',
      visits: 'Visitas',
      showMap: 'Ver origen de los visitantes'
    }
  },
  date: {
    simpleFormat: 'dd/MM/yyyy',
    dateAndTime: 'DD/MM/YYYY HH:mm',
    simpleFormatDash: 'DD-MM-YYYY'
  },
  emailsList: {
    title: 'E-mails capturados',
    emailColumn: 'Dirección de E-mail',
    dateColumn: 'Fecha',
    searchPlaceholder: 'Buscar dirección',
    capturedEmails: 'Ningún e-mail capturado | 1 e-mail capturado | {count} e-mails capturados',
    export: {
      button: 'Exportar',
      fileName: 'Lista de e-mails capturados'
    }
  },
  pagination: {
    previous: 'Anterior',
    next: 'Próximo'
  },
  chart: {
    period: 'Período',
    date: {
      from: 'De',
      to: 'a',
      invalidPeriod: 'La fecha inicial del periodo debe ser menor de que la fecha final. Por favor, selecciona otro período de fechas.'
    },
    filter: 'Filtrar y exhibir gráfico',
    granularity: {
      hour: {
        label: 'Hora',
        format: 'DD/MM [a las] HH[h]'
      },
      day: {
        label: 'Día',
        format: 'DD/MM'
      }
    },
    noData: 'Sin datos en el período'
  },
  locations: {
    title: 'Origen de los visitantes',
    searchPlaceholder: 'Filtrar localidad',
    visitors_percent: '% de los visitantes',
    visitors: 'Ningún visitante | 1 visitante | {count} visitantes',
    cities: 'de 1 ciudad | de {count} ciudades',
    countries: 'en 1 país | en {count} países',
    not_identified: 'No identificado'
  },
  notifications: {
    noNotifications: 'No hay notificaciones nuevas.',
    unableLoad: 'No pudimos cargar notificaciones en este momento.'
  },
  loading: {
    title: 'Estamos procesando la acción. Espere mientras cargamos los datos.',
    subtitle: 'La solicitud puede tardar unos minutos.'
  },
  error: {
    notFound: {
      title: 'No se pueden encontrar métricas para esta página',
      buttons: {
        home: 'Ir a la página de inicio'
      }
    },
    metricsProcess: {
      title: 'Tuvimos un error por aquí',
      subtitle: 'No podemos cargar esta página en este momento, pero estamos trabajando para resolver el problema. Vuelve a intentarlo en unos minutos. Si el problema persiste, puede ponerse en contacto con nuestro Soporte.',
      buttons: {
        home: 'Intentar nuevamente',
        support: 'Hablar con soporte'
      }
    }
  }
});

/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  analytics: {
    header: {
      title: 'Métricas',
      back: 'Voltar para as minhas páginas',
      subtitle: {
        edit: 'Editar'
      }
    },
    info: {
      cacheDelay: '*A atualização das métricas da página pode ocorrer em até um dia'
    }
  },
  boxes: {
    total: 'Total',
    conversions: {
      title: 'Conversões',
      conversionRate: 'Taxa de Conversão',
      showEmails: 'Ver e-mails capturados',
      conversionType: 'Identificador da conversão',
      subscriptionIdentifier: 'Inscrição no formulário de e-mail',
      linkIdentifier: 'Link {identifier}'
    },
    duration: {
      title: 'Duração média'
    },
    visitors: {
      title: 'Visitantes',
      unique: 'Únicos',
      local: 'Local',
      country: 'País',
      visits: 'Visitas',
      showMap: 'Ver origem dos visitantes'
    }
  },
  date: {
    simpleFormat: 'dd/MM/yyyy',
    dateAndTime: 'DD/MM/YYYY HH:mm',
    simpleFormatDash: 'DD-MM-YYYY'
  },
  emailsList: {
    title: 'E-mails capturados',
    emailColumn: 'Endereço de E-mail',
    dateColumn: 'Data',
    searchPlaceholder: 'Procurar endereço',
    capturedEmails: 'Nenhum e-mail capturado | 1 e-mail capturado | {count} e-mails capturados',
    export: {
      button: 'Exportar',
      fileName: 'Lista de e-mails capturados'
    }
  },
  pagination: {
    previous: 'Anterior',
    next: 'Próximo'
  },
  chart: {
    period: 'Período',
    date: {
      from: 'De',
      to: 'Até',
      invalidPeriod: 'A data inicial do período deve ser menor do que a data final. Por favor, selecione outro período de datas.'
    },
    filter: 'Filtrar e exibir gráfico',
    granularity: {
      hour: {
        label: 'Hora',
        format: 'DD/MM [às] HH[h]'
      },
      day: {
        label: 'Dia',
        format: 'DD/MM'
      }
    },
    noData: 'Sem dados no período'
  },
  locations: {
    title: 'Origem dos visitantes',
    searchPlaceholder: 'Filtrar localidade',
    visitors_percent: '% dos visitantes',
    visitors: 'Nenhum visitante | 1 visitante | {count} visitantes',
    cities: 'de 1 cidade | de {count} cidades',
    countries: 'em 1 país | em {count} países',
    not_identified: 'Não identificado'
  },
  notifications: {
    noNotifications: 'Não há novas notificações.',
    unableLoad: 'Não foi possível carregar as notificações no momento.'
  },
  loading: {
    title: 'Estamos processando a ação. Aguarde enquanto carregamos os dados.',
    subtitle: 'A requisição pode demorar alguns minutos.'
  },
  error: {
    notFound: {
      title: 'Não foi possível encontrar as métricas desta página',
      buttons: {
        home: 'Ir para página inicial'
      }
    },
    metricsProcess: {
      title: 'Tivemos um erro por aqui',
      subtitle: 'Não conseguimos carregar esta página agora, mas estamos trabalhando para resolver o problema. Tente novamente em alguns minutos. Se o problema continuar, você pode entrar em contato com o nosso Suporte.',
      buttons: {
        home: 'Tentar novamente',
        support: 'Falar com Suporte'
      }
    }
  }
});

/***/ }),

/***/ 761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gtm__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_klicknotify__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_klicknotify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_klicknotify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hotmart_org_ca_saas_pages_universal_navigator_2x__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_universal_navigator__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_rebrand__ = __webpack_require__(43);













__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_4_klicknotify___default.a.init();

var VueApp = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */],
  rebrandConfigs: __WEBPACK_IMPORTED_MODULE_11__config_rebrand__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
  id: "UA-115650804-1,UA-166451857-1".split(','),
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  autoTracking: {
    page: "production" === 'production' || "production" === 'staging'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_gtm___default.a, {
  id: "GTM-M7Z594X,GTM-NZB9QBR".split(','),
  defer: false,
  enabled: true,
  loadScript: true,
  vueRouter: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__hotmart_org_ca_saas_pages_universal_navigator_2x__["a" /* default */], { store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], i18n: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */], configs: __WEBPACK_IMPORTED_MODULE_10__config_universal_navigator__["a" /* default */] });

__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a.onScriptLoaded().then(function () {
  VueApp.$mount('#app');
});

/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_Auth_components_Main__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_Auth_components_Logout__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Auth_components_StartLogout__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_Auth_components_Surrogate__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Emails__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Locations__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Show__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_rebrand__ = __webpack_require__(43);









/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'Index',
  beforeEnter: function beforeEnter() {
    window.location.replace(__WEBPACK_IMPORTED_MODULE_7__config_rebrand__["a" /* default */].urls.KLICKART_URL);
  }
}, {
  path: '/auth',
  name: 'Auth',
  component: __WEBPACK_IMPORTED_MODULE_0__screens_Auth_components_Main__["a" /* default */]
}, {
  path: '/auth/login',
  name: 'Auth',
  component: __WEBPACK_IMPORTED_MODULE_0__screens_Auth_components_Main__["a" /* default */]
}, {
  path: '/auth/renew',
  name: 'Renew',
  component: __WEBPACK_IMPORTED_MODULE_0__screens_Auth_components_Main__["a" /* default */]
}, {
  path: '/auth/start-logout',
  name: 'Start-Logout',
  component: __WEBPACK_IMPORTED_MODULE_2__screens_Auth_components_StartLogout__["a" /* default */]
}, {
  path: '/auth/logout',
  name: 'Logout',
  component: __WEBPACK_IMPORTED_MODULE_1__screens_Auth_components_Logout__["a" /* default */]
}, {
  path: '/auth/surrogate',
  name: 'Surrogate',
  component: __WEBPACK_IMPORTED_MODULE_3__screens_Auth_components_Surrogate__["a" /* default */]
}, {
  path: '/:pageIdentifier',
  name: 'Show',
  component: __WEBPACK_IMPORTED_MODULE_6__Show__["a" /* default */]
}, {
  path: '/:pageIdentifier/emails',
  name: 'EmailList',
  component: __WEBPACK_IMPORTED_MODULE_4__Emails__["a" /* default */]
}, {
  path: '/:pageIdentifier/locations',
  name: 'Locations',
  component: __WEBPACK_IMPORTED_MODULE_5__Locations__["a" /* default */]
}]);

/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (router, store) {
  router.beforeEach(function (to, from, next) {
    if (to.name === 'Show') {
      store.dispatch('metrics/resetChartData');
    }
    next();
  });
});

/***/ }),

/***/ 764:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(303);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var rootState = _ref.rootState;
  var redirect = rootState.route.query.redirect;

  if (redirect) {
    window.location = redirect;
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ name: 'Index' });
});

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(764);


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    init: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
  }
});

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request_page__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_file__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_date__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(323);






var PageAPI = new __WEBPACK_IMPORTED_MODULE_0__services_request_page__["a" /* default */]();

var params = {};

var request = function request(commit, slug) {
  return PageAPI.emails(slug, { catchError: true, params: params }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_4__types__["a" /* default */].EMAIL_LIST_SET_LIST, response.data);
  });
};

var actions = {};

actions.resetEmailRequestParams = function () {
  params = {};
};

actions.requestEmails = function (_ref) {
  var commit = _ref.commit,
      state = _ref.state;

  params.paginationPage = state.page;
  return request(commit, state.slug);
};

actions.getCapturedEmails = function (_ref2, slug) {
  var dispatch = _ref2.dispatch,
      commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__types__["a" /* default */].EMAIL_LIST_SET_SLUG, slug);
  dispatch('requestEmails', __WEBPACK_IMPORTED_MODULE_4__types__["a" /* default */].EMAIL_LIST_SET_LIST);
};

actions.getEmailsOfPage = function (_ref3, page) {
  var dispatch = _ref3.dispatch,
      commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__types__["a" /* default */].EMAIL_LIST_SET_PAGE, page);
  dispatch('requestEmails', __WEBPACK_IMPORTED_MODULE_4__types__["a" /* default */].EMAIL_LIST_SET_LIST);
};

actions.searchCapturedEmails = function (_ref4, _ref5) {
  var commit = _ref4.commit,
      state = _ref4.state;
  var target = _ref5.target;

  commit(__WEBPACK_IMPORTED_MODULE_4__types__["a" /* default */].EMAIL_LIST_SET_PAGE, 1);
  params = { paginationPage: 1 };
  if (target.value) {
    params.query = target.value;
  }

  return request(commit, state.slug);
};

actions.exportEmails = function (_ref6) {
  var state = _ref6.state;
  return PageAPI.exportEmails(state.slug, { catchError: true, responseType: 'blob' }).then(function (response) {
    var today = __WEBPACK_IMPORTED_MODULE_2__services_date__["a" /* default */].todayFormated(__WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('date.simpleFormatDash'));
    var fileName = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('emailsList.export.fileName') + ' - Hotmart Pages - ' + today + '.csv';
    __WEBPACK_IMPORTED_MODULE_1__helpers_file__["a" /* default */].download(response.data, 'text/csv', fileName);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {};

getters.emailsList = function (state) {
  return state.emailsList;
};
getters.numberOfEmails = function (state) {
  return state.numberOfEmails;
};
getters.numberOfPages = function (state) {
  return state.numberOfPages;
};
getters.currentPage = function (state) {
  return state.page;
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(769);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(323);


var _mutations;



var state = {
  emailsList: [],
  numberOfEmails: 0,
  numberOfPages: 1,
  page: 1,
  slug: ''
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].EMAIL_LIST_SET_LIST, function (state, data) {
  state.emailsList = data.emails;
  state.numberOfPages = data.total_pages;
  state.numberOfEmails = data.total;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].EMAIL_LIST_SET_PAGE, function (state, page) {
  state.page = page;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].EMAIL_LIST_SET_SLUG, function (state, slug) {
  state.slug = slug;
}), _mutations);

/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request_page__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(324);



var api = new __WEBPACK_IMPORTED_MODULE_0__services_request_page__["a" /* default */]();
var actions = {};
var params = {};

var request = function request(commit, pageIdentifier) {
  return api.locations(pageIdentifier, { catchError: true, params: params }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOCATIONS_SET_LIST, response.data);
  });
};

actions.getCoordinates = function (_ref) {
  var commit = _ref.commit,
      state = _ref.state;
  return api.locationCoordinates(state.pageIdentifier, { catchError: true }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOCATIONS_SET_COORDINATES, response.data);
  });
};

actions.requestLocations = function (_ref2) {
  var commit = _ref2.commit,
      state = _ref2.state;

  params.paginationPage = state.page;
  return request(commit, state.pageIdentifier);
};

actions.getLocations = function (_ref3, pageIdentifier) {
  var dispatch = _ref3.dispatch,
      commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOCATIONS_SET_PAGEIDENTIFER, pageIdentifier);
  dispatch('requestLocations', __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOCATIONS_SET_LIST);
};

actions.getLocationsOfPage = function (_ref4, page) {
  var dispatch = _ref4.dispatch,
      commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOCATIONS_SET_PAGE, page);
  dispatch('requestLocations', __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOCATIONS_SET_LIST);
};

actions.searchLocations = function (_ref5, _ref6) {
  var commit = _ref5.commit,
      state = _ref5.state;
  var target = _ref6.target;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOCATIONS_SET_PAGE, 1);
  params = { paginationPage: 1 };
  if (target.value) {
    params.query = target.value;
  }

  return request(commit, state.pageIdentifier);
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {};

getters.coordinates = function (state) {
  return state.coordinates;
};
getters.locations = function (state) {
  return state.locations;
};
getters.numberOfPages = function (state) {
  return state.numberOfPages;
};
getters.currentPage = function (state) {
  return state.page;
};
getters.total = function (state) {
  return state.total;
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(773);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),

/***/ 773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_metrics__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(324);


var _mutations;




var state = {
  locations: [],
  coordinates: [],
  total: {
    visits: 0,
    cities: 0,
    countries: 0
  },
  numberOfPages: 0,
  page: 1,
  pageIdentifier: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].LOCATIONS_SET_PAGE, function (state, data) {
  state.page = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].LOCATIONS_SET_LIST, function (state, data) {
  if (!data) {
    state.locations = [];
    state.total = { visits: 0, cities: 0, countries: 0 };
    return;
  }

  state.locations = data.locations;
  state.numberOfPages = data.total_pages;
  state.total = data.total;

  state.locations.forEach(function (location) {
    location.visitsPercentage = __WEBPACK_IMPORTED_MODULE_1__helpers_metrics__["a" /* default */].percentage(location.visits, state.total.visits);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].LOCATIONS_SET_COORDINATES, function (state, data) {
  state.coordinates = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].LOCATIONS_SET_PAGEIDENTIFER, function (state, pageIdentifier) {
  state.pageIdentifier = pageIdentifier;
}), _mutations);

/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_request_page__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(325);




var api = new __WEBPACK_IMPORTED_MODULE_1__services_request_page__["a" /* default */]();
var actions = {};

actions.get = function (_ref, _ref2) {
  var commit = _ref.commit;
  var pageIdentifier = _ref2.pageIdentifier,
      _ref2$filters = _ref2.filters,
      filters = _ref2$filters === undefined ? {} : _ref2$filters;
  return api.metrics(pageIdentifier, {
    catchError: true,
    params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      paginationPage: 1,
      limit: 3
    }, filters)
  }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].GET_METRICS, response.data);
    return { data: response.data, status: response.status };
  }).catch(function (error) {
    return {
      data: error.response.data,
      status: error.response.status
    };
  });
};

actions.getChartData = function (_ref3, _ref4) {
  var commit = _ref3.commit;
  var pageIdentifier = _ref4.pageIdentifier,
      filters = _ref4.filters;
  return api.chartData(pageIdentifier, { catchError: true, params: filters }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].SET_CHART_DATA, { data: response.data, filters: filters });
  });
};

actions.resetChartData = function (_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].RESET_CHART_DATA);
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {};

getters.visitors = function (state) {
  return state.visitors;
};
getters.chart = function (state) {
  return state.chart;
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(777);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_charts__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_metrics__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(325);


var _mutations;





var state = {
  visitors: {},
  chart: {
    types: __WEBPACK_IMPORTED_MODULE_1__helpers_charts__["a" /* default */].getChartsTypes(),
    data: [],
    colors: __WEBPACK_IMPORTED_MODULE_1__helpers_charts__["a" /* default */].colors,
    keys: __WEBPACK_IMPORTED_MODULE_1__helpers_charts__["a" /* default */].keys
  }
};

var formatTime = function formatTime(duration) {
  var seconds = parseInt(duration % 60, 10);
  var minutes = parseInt(duration / 60 % 60, 10);
  var hours = parseInt(duration / (60 * 60) % 24, 10);

  hours = hours > 0 ? hours + 'h ' : '';
  minutes = minutes > 0 ? minutes + 'min ' : '';
  seconds = seconds > 0 ? seconds + 's' : '~1s';

  return '' + hours + minutes + seconds;
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* default */].GET_METRICS, function (state, data) {
  if (!data.visitors) {
    return;
  }

  var visitors = data.visitors;

  state.visitors = visitors;
  state.visitors.uniquePercentage = __WEBPACK_IMPORTED_MODULE_2__helpers_metrics__["a" /* default */].percentage(visitors.unique, visitors.total);
  state.visitors.registeredEmailsPercentage = __WEBPACK_IMPORTED_MODULE_2__helpers_metrics__["a" /* default */].percentage(visitors.registered_emails, visitors.total);

  state.visitors.devices.forEach(function (device) {
    device.percentage = __WEBPACK_IMPORTED_MODULE_2__helpers_metrics__["a" /* default */].percentage(device.total, visitors.total);
  });

  state.visitors.clicks.forEach(function (click) {
    click.percentage = __WEBPACK_IMPORTED_MODULE_2__helpers_metrics__["a" /* default */].percentage(click.conversions, visitors.total);
  });

  state.visitors.averageTimeElapsed = formatTime(visitors.average_time_elapsed);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* default */].SET_CHART_DATA, function (state, _ref) {
  var data = _ref.data,
      filters = _ref.filters;

  data.forEach(function (metric) {
    metric.period = __WEBPACK_IMPORTED_MODULE_1__helpers_charts__["a" /* default */].formatPeriod(metric.period, filters.granularity);
  });

  state.chart.data = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* default */].RESET_CHART_DATA, function (state) {
  state.chart.data = [];
}), _mutations);

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(327);


var actions = {};

actions.defineFromResponseStatus = function (_ref, responseStatus) {
  var commit = _ref.commit;

  if (responseStatus === 202) {
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_GLOBAL_RESPONSE_STATUS, 'ACCEPTED');
    return;
  }

  if (responseStatus === 404) {
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_GLOBAL_RESPONSE_STATUS, 'NOT_FOUND');
    return;
  }

  if (responseStatus === 422) {
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_GLOBAL_RESPONSE_STATUS, 'UNPROCESSABLE_ENTITY');
    return;
  }

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_GLOBAL_RESPONSE_STATUS, 'OK');
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_defaultStatus__ = __webpack_require__(326);


var getters = {};

getters.isNotFound = function (state) {
  return state.globalResponseStatus === __WEBPACK_IMPORTED_MODULE_0__config_defaultStatus__["a" /* default */].NOT_FOUND;
};
getters.isUnprocessableEntity = function (state) {
  return state.globalResponseStatus === __WEBPACK_IMPORTED_MODULE_0__config_defaultStatus__["a" /* default */].UNPROCESSABLE_ENTITY;
};
getters.isAccepted = function (state) {
  return state.globalResponseStatus === __WEBPACK_IMPORTED_MODULE_0__config_defaultStatus__["a" /* default */].ACCEPTED;
};
getters.isOk = function (state) {
  return state.globalResponseStatus === __WEBPACK_IMPORTED_MODULE_0__config_defaultStatus__["a" /* default */].OK;
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(781);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_defaultStatus__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(327);




var state = {
  globalResponseStatus: 'accepted'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].SET_GLOBAL_RESPONSE_STATUS, function (state, statusKey) {
  state.globalResponseStatus = __WEBPACK_IMPORTED_MODULE_1__config_defaultStatus__["a" /* default */][statusKey];
});

/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(36);


var messages = __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].messages;

var locale = __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].locale;

/* unused harmony default export */ var _unused_webpack_default_export = (messages[locale]);

/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_control__ = __webpack_require__(1294);


var controlApp = {};

var createControlButton = function createControlButton(buttonClass, elementClass, handler) {
  var button = document.createElement('button');
  button.className = buttonClass;

  button.addEventListener('click', handler);
  var element = document.createElement('div');
  element.className = elementClass + ' ol-unselectable ol-control';
  element.appendChild(button);

  return element;
};

controlApp.centerToUserLocation = function (map) {
  var handler = function handler() {
    navigator.geolocation.getCurrentPosition(function (position) {
      map.getView().setCenter([position.coords.longitude, position.coords.latitude]);
    });
  };

  var element = createControlButton('icon-kp-gps', 'center-user-location', handler);

  return new __WEBPACK_IMPORTED_MODULE_0_ol_control__["a" /* Control */]({ element: element });
};

/* harmony default export */ __webpack_exports__["a"] = (controlApp);

/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_style__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_layer_Tile__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_geom_Point__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_Feature__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_source__ = __webpack_require__(1347);







var map = {};
var blue = function blue(alpha) {
  return 'RGBA(98, 123, 162, ' + alpha + ')';
};
var center = null;

map.settings = function () {
  return {
    center: center || [0, 0],
    zoom: 3,
    projection: 'EPSG:4326',
    clickMargin: 5
  };
};

map.getPointStyle = function () {
  return new __WEBPACK_IMPORTED_MODULE_0_ol_style__["a" /* Style */]({
    image: new __WEBPACK_IMPORTED_MODULE_0_ol_style__["b" /* Circle */]({
      radius: 4,
      fill: new __WEBPACK_IMPORTED_MODULE_0_ol_style__["c" /* Fill */]({ color: blue('0.7') }),
      stroke: new __WEBPACK_IMPORTED_MODULE_0_ol_style__["d" /* Stroke */]({ color: blue('0.5'), width: 10 })
    })
  });
};

map.createPoints = function (locations) {
  var features = [];

  locations.forEach(function (location) {
    var feature = new __WEBPACK_IMPORTED_MODULE_4_ol_Feature__["a" /* default */]({
      geometry: new __WEBPACK_IMPORTED_MODULE_3_ol_geom_Point__["a" /* default */]([location.city_longitude, location.city_latitude]),
      name: location.city_name,
      data: location.visits
    });

    feature.setStyle(map.getPointStyle());
    features.push(feature);
  });

  center = [locations[0].city_longitude, locations[0].city_latitude];
  return features;
};

map.createVectorLayer = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var vectorSource = new __WEBPACK_IMPORTED_MODULE_5_ol_source__["a" /* Vector */]();

  if (data && data.length > 0) {
    vectorSource.addFeatures(map.createPoints(data));
  }

  return new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({ source: vectorSource });
};

map.createOpenStreetLayer = function () {
  return new __WEBPACK_IMPORTED_MODULE_2_ol_layer_Tile__["a" /* default */]({ source: new __WEBPACK_IMPORTED_MODULE_5_ol_source__["b" /* OSM */]() });
};

/* harmony default export */ __webpack_exports__["a"] = (map);

/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instance__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_authService__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_tokenStrategies_tokenStrategyFactory__ = __webpack_require__(123);








function getToken() {
  var casTokenName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__auth_authService__["c" /* isColaborator */])() ? 'colaborator' : 'cas';
  var casToken = function casToken() {
    return __WEBPACK_IMPORTED_MODULE_6__auth_tokenStrategies_tokenStrategyFactory__["a" /* default */].getTokenStrategy(casTokenName).getToken();
  };
  var jwtToken = function jwtToken() {
    return __WEBPACK_IMPORTED_MODULE_6__auth_tokenStrategies_tokenStrategyFactory__["a" /* default */].getTokenStrategy('jwt').getToken();
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__auth_authService__["b" /* casEnabled */])() ? casToken() : jwtToken();
}

var configRequest = function configRequest() {
  return {
    headers: {
      Authorization: 'Bearer ' + getToken(),
      Accept: 'application/json',
      'Content-Language': __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* locale */]
    }
  };
};

var API = function () {
  function API() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, API);

    this.path = config.path;

    this.axios = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instance__["a" /* default */])();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(API, [{
    key: 'get',
    value: function get() {
      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.axios.get(this.path + '/' + resource, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, configRequest(), config));
    }
  }, {
    key: 'put',
    value: function put() {
      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments[1];
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.axios.put(this.path + '/' + resource, data, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, configRequest(), config));
    }
  }, {
    key: 'post',
    value: function post() {
      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments[1];
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var path = this.path + '/' + resource;

      return this.axios.post(path, data, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, configRequest(), config));
    }
  }, {
    key: 'delete',
    value: function _delete() {
      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.axios.delete(this.path + '/' + resource, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, configRequest(), config));
    }
  }]);

  return API;
}();

/* harmony default export */ __webpack_exports__["a"] = (API);

/***/ }),

/***/ 786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors_token__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_rebrand__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_authService__ = __webpack_require__(57);





var API_ENDPOINT = __WEBPACK_IMPORTED_MODULE_2__config_rebrand__["a" /* default */].urls.API_ENDPOINT;

var instance = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (instance) {
    return instance;
  }

  instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: API_ENDPOINT,
    withCredentials: true,
    tokenType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth_authService__["b" /* casEnabled */])() ? 'cas' : 'jwt'
  });

  instance.interceptors.response.use(function (response) {
    return response;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__interceptors_token__["a" /* default */])(instance));

  return instance;
});

/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instance__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_tokenStrategies_tokenStrategyFactory__ = __webpack_require__(123);






var jwtToken = function jwtToken() {
  return __WEBPACK_IMPORTED_MODULE_4__auth_tokenStrategies_tokenStrategyFactory__["a" /* default */].getTokenStrategy('jwt').getToken();
};

var configRequest = function configRequest() {
  return {
    headers: {
      Authorization: 'Bearer ' + jwtToken(),
      Accept: 'application/json'
    }
  };
};

var EditorAPI = function () {
  function EditorAPI() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EditorAPI);

    this.path = config.path;

    this.axios = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instance__["a" /* default */])();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EditorAPI, [{
    key: 'get',
    value: function get() {
      var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.axios.get(this.path + '/' + resource, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, configRequest(), config));
    }
  }]);

  return EditorAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (EditorAPI);

/***/ }),

/***/ 788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors_token__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_rebrand__ = __webpack_require__(43);




var EDITOR_API_ENDPOINT = __WEBPACK_IMPORTED_MODULE_2__config_rebrand__["a" /* default */].urls.EDITOR_API_ENDPOINT;

var instance = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (instance) {
    return instance;
  }

  instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: EDITOR_API_ENDPOINT,
    tokenType: 'jwt'
  });

  instance.interceptors.response.use(function (response) {
    return response;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__interceptors_token__["a" /* default */])(instance));

  return instance;
});

/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorApi__ = __webpack_require__(787);







var EditorApiPage = function (_EditorAPI) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(EditorApiPage, _EditorAPI);

  function EditorApiPage() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EditorApiPage);

    config.path = 'v1/pages';

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EditorApiPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(EditorApiPage)).call(this, config));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EditorApiPage, [{
    key: 'page',
    value: function page(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get('' + pageIdentifier, params);
    }
  }]);

  return EditorApiPage;
}(__WEBPACK_IMPORTED_MODULE_5__editorApi__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EditorApiPage);

/***/ }),

/***/ 790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors_token__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_rebrand__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_authService__ = __webpack_require__(57);





var API_ENDPOINT = __WEBPACK_IMPORTED_MODULE_2__config_rebrand__["a" /* default */].urls.KLICKART_URL;

var instance = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (!instance) {
    instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
      baseURL: API_ENDPOINT,
      withCredentials: true,
      tokenType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth_authService__["b" /* casEnabled */])() ? 'cas' : 'jwt'
    });
    instance.interceptors.response.use(function (response) {
      return response;
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__interceptors_token__["a" /* default */])(instance));
  }
  return instance;
});

/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__klickart__ = __webpack_require__(328);







var KlickartPage = function (_Klickart) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(KlickartPage, _Klickart);

  function KlickartPage() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, KlickartPage);

    config.path = 'partials/page_item';

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (KlickartPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(KlickartPage)).call(this, config));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(KlickartPage, [{
    key: 'page',
    value: function page(pageIdentifier) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.get('' + pageIdentifier, params);
    }
  }]);

  return KlickartPage;
}(__WEBPACK_IMPORTED_MODULE_5__klickart__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KlickartPage);

/***/ })

},[761]);


// WEBPACK FOOTER //
// static/js/app.6148eb5511e010a9d0ee.js